import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const FRENCH = {
  type: 'fr-FR',
  languageNames: {
    en: 'Anglais',
    no: 'Norvégien',
    nb: 'Norvégien',
    de: 'Allemand',
    fr: 'Français',
    sv: 'Suédois',
    se: 'Suédois',
    da: 'Danois',
    it: 'Italien',
    fi: 'Finnois',
  },
  global: {
    noDataAvailable: 'Aucune donnée disponible',
    move: 'Déplacer',
    rotate: 'Pivoter',
    model: 'Modèle',
    data: 'Données',
    all: 'Tous',
    controls: 'Contrôles',
    lastUpdated: 'Dernière mise à jour',
    noData: 'Aucune donnée',
    custom: 'Personnalisé',
    name: 'Nom',
    setpoints: 'Setpoints',
    email: 'E-mail',
    date: 'Date',
    timestamp: 'Horodatage',
    address: 'Adresse',
    street: 'Rue',
    postcode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    language: 'Langue',
    timezone: 'Fuseau horaire',
    new: 'Nouveau',
    from: 'De',
    until: 'À',
    selectStartDate: 'Choisir la date de début',
    selectEndDate: 'choisir la date de fin',
    copied: 'Copié',
    average: 'Moyenne',
    min: 'Min',
    max: 'Max',
    last: 'Dernière',
    type: 'Type',
    role: 'Rôle',
    category: 'Catégorie',
    description: 'Description',
    status: 'Statut',
    public: 'Public',
    active: 'Actif',
    inactive: 'Inactif',
    hidden: 'Masqué',
    visible: 'Visible',
    show: 'Afficher',
    hide: 'Masquer',
    enabled: 'Activé',
    disabled: 'Désactivé',
    actionRequired: 'Action requise',
    success: 'Succès',
    none: 'Aucun',
    error: 'Erreur',
    basicInfo: 'Informations de base',
    information: 'Informations',
    display: 'Affichage',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saveSuccess: 'Enregistré',
    saveError: 'Échec de l’enregistrement',
    search: 'Rechercher',
    add: 'Ajouter',
    close: 'Fermer',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    cancel: 'Annuler',
    update: 'Mettre à jour',
    updating: 'Mise à jour...',
    undo: 'Annuler',
    done: 'Terminé',
    delete: 'Supprimer',
    discard: 'Abandonner',
    rename: 'Renommer',
    editName: 'Modifier le nom',
    download: 'Télécharger',
    open: 'Ouvrir',
    password: 'Mot de passe',
    login: 'Connexion',
    loginWithAzure: 'Se connecter avec Azure',
    invalidCredentials: 'Identifiants invalides',
    loginTooManyAttempts:
      'Trop de tentatives de connexion, réessayez dans quelques minutes',
    loginInactiveUser: "Ce compte utilisateur n'est plus actif",
    loginUnavailable:
      'Connexion impossible pour le moment, réessayez plus tard',
    welcome: 'Bienvenue chez Sastech',
    loginSubtitle: 'Connectez-vous pour accéder à votre tableau de bord',
    or: 'ou',
    key: 'Clé',
    back: 'Retour',
    apply: 'Appliquer',
    inDevelopment: 'En développement',
    notAuthorized: 'Non autorisé',
    heating: 'Chauffage',
    cooling: 'Refroidissement',
    ventilation: 'Ventilation',
    climate: 'Climat intérieur',
    battery: 'Batterie',
    batteries: 'Batteries',
    capabilities: 'Fonctionnalités',
    moveTo: 'Déplacer vers',
    building: 'Bâtiment',
    buildings: 'Bâtiments',
    floor: 'Étage',
    floors: 'Étages',
    sensors: 'Capteurs',
    sensor: 'Capteur',
    controller: 'Contrôleur',
    energySource: "Source d'énergie",
    session: 'Session',
    addDevice: 'Ajouter un appareil',
    device: 'Appareil',
    devices: 'Appareils',
    selectDevice: 'Sélectionnez un appareil',
    edit: 'Modifier',
    serialNumber: 'Numéro de série',
    trash: 'Corbeille',
    actions: 'Actions',
    restore: 'Restaurer',
    emptyTrash: 'Vider la corbeille',
    selectCategory: 'Sélectionner...',
    create: 'Créer',
    monthChartText: [
      'Jan',
      'Fév',
      'Mar',
      'Avr',
      'Mai',
      'Juin',
      'Juil',
      'Aoû',
      'Sep',
      'Oct',
      'Nov',
      'Déc',
    ],
    today: 'Aujourd’hui',
    weekdaysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    weekdays: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    title: 'Titre',
    to: 'à',
    remove: 'Supprimer',
    inspect: 'Inspecter',
    compare: 'Comparer',
    export: 'Exporter',
    total: 'Total',
    activate: 'Activer',
    color: 'Couleur',
    text: 'Texte',
    link: 'Lien',
    frame: 'Cadre',
    info: 'Info',
    saveChanges: 'Enregistrer les modifications',
    sidebarMenu: 'Barre latérale',
    icons: 'Icônes',
    ok: 'OK',
    exit: 'Quitter',
    exportImage: "Exporter l'image",
    exportSelected: 'Exporter la sélection',
    directions: {
      top: 'Haut',
      bottom: 'Bas',
      right: 'Droite',
      left: 'Gauche',
      front: 'Avant',
      back: 'Arrière',
      isometric: 'Isométrique',
    },
    switchVendor: 'Changer de client',
    searchVendors: 'Rechercher des clients...',
    noVendorsFound: 'Aucun client trouvé',
  },
  chart: {
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    rotate: 'Pivoter',
    fullscreen: 'Plein écran',
    rotateTip: 'Cliquez et faites glisser pour faire pivoter le graphique',
  },
  data: {
    loading: 'Chargement...',
    loadingData: 'Chargement des données...',
    noResults: 'Aucun résultat trouvé.',
    error: 'Erreur',
    failedToLoadData: 'Échec du chargement des données',
    noDataAvailable: 'Aucune donnée disponible',
  },
  general: {
    temperature: 'Température',
    co2: 'CO₂',
    humidity: 'Humidité',
    zone: 'Zone',
    data: 'Données',
    edit: 'Modifier',
    analyze: 'Analyser',
    chartType: 'Type de graphique',
    toggleSeries: 'Basculer les séries',
    resetFilters: 'Réinitialiser les filtres',
    exportData: 'Exporter les données',
  },
  chat: {
    // French for the ability to chat with others.
    title: 'Sastech Chat',
    placeholder: 'Écrivez un message…',
    send: 'Envoyer',
    unknownUser: 'Utilisateur inconnu',
  },
  navigation: {
    dashboard: 'Tableau de bord',
    eosDashboard: 'Aperçu',
    devices: 'Appareils',
    map: 'Carte',
    buildings: 'Bâtiments',
    reports: 'Rapports',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    sastech: 'Paramètres Sastech',
    analytics: 'Analytique',
    buildings3D: 'Bâtiments 3D',
    superSettings: 'Sastech',
    buildingInspection: 'Inspection',
    expandSidebar: 'Développer la barre latérale',
    collapseSidebar: 'Réduire la barre latérale',
    userCalendar: 'Calendrier Utilisateur',
    energyLabelLeads: 'Leads étiquetage énergétique',
  },
  reports: {
    title: 'Rapports',
    orderReport: 'Commander un rapport',
    orderDescription: 'Le rapport apparaît dans la liste dès qu’il est prêt.',
    reportType: 'Type de rapport',
    kinds: {
      eos_weekly: 'Rapport énergétique hebdomadaire',
      eos_monthly: 'Rapport énergétique mensuel',
    },
    period: 'Période',
    week: 'Semaine {week}',
    reportLanguage: 'Langue du rapport',
    submit: 'Commander',
    submitting: 'Commande en cours…',
    status: {
      queued: 'En attente',
      generating: 'En cours',
      completed: 'Prêt',
      failed: 'Échoué',
    },
    exportExcel: 'Télécharger Excel',
    exportPdf: 'Télécharger le PDF',
    makePdf: 'Créer le PDF',
    pdfPending: 'PDF en cours de création…',
    confirmDeleteTitle: 'Supprimer le rapport',
    confirmDeleteMessage:
      'Le rapport est retiré de la liste. Cette action est irréversible.',
    noReports: 'Aucun rapport pour le moment. Commandez le premier.',
    noSearchHits: 'Aucun rapport ne correspond à la recherche.',
    noMeters: "Le bâtiment n'a aucun compteur d'énergie actif.",
    duplicateOrder: 'Le même rapport est déjà en cours de création.',
    orderError: 'Impossible de commander le rapport',
    orderSuccess: 'Le rapport est commandé et en cours de création.',
    deleteError: 'Impossible de supprimer le rapport',
    pdfError: 'Impossible de commander le PDF',
    pdfRequested: 'Le PDF est commandé et en cours de création.',
    requestedBy: 'Commandé par',
    ordered: 'Commandé',
    daysAgo: 'il y a {count} jours',
    sheets: {
      summary: 'Résumé',
      days: 'Par jour',
      hours: 'Par heure',
      sources: 'Compteurs',
      profile: 'Profil journalier',
    },
    excel: {
      parameter: 'Paramètre',
      value: 'Valeur',
      unit: 'Unité',
      delivered: 'Énergie livrée',
      production: 'Production propre',
      export: 'Exporté',
      net: 'Utilisé dans le bâtiment',
      baseline: 'Référence',
      previousYear: 'Année précédente',
      co2: 'CO2',
      baselineCo2: 'CO2 de référence',
      hoursWithData: 'Heures avec données',
      meanKW: 'Puissance moyenne',
      maxKW: 'Heure la plus élevée',
      maxAt: 'Heure la plus élevée à',
      baseLoadKW: 'Charge de base',
      nightKW: 'Charge de nuit 00–05',
      peakHours: 'Heures à 90 % du max ou plus',
      weekday: 'Jour de la semaine',
      time: 'Heure',
      source: 'Compteur',
      missingHours: 'Heures manquantes',
      energy: 'Énergie',
      co2Factor: 'Facteur CO2',
      role_delivered: 'énergie livrée',
      role_production: 'production propre',
      role_export: 'export',
      role_excluded: 'non compté',
    },
  },
  map: {
    addBuildingAtCenter: 'Ajouter un bâtiment au centre de la carte',
  },
  pagination: {
    rowsPerPage: 'Lignes par page',
    rangeSeparator: 'sur',
  },
  devices: {
    title: 'Aperçu des appareils',
    reset: 'Réinitialiser',
    noDevices: 'Aucun appareil trouvé.',
    unnamed: 'Appareil sans nom',
    copySensorTag: 'Copier le tag du capteur',
    graph: {
      inspect: 'Inspecter',
      edit: 'Modifier',
      chartType: 'Type de graphique',
      toggleSeries: 'Basculer les séries',
      resetFilters: 'Réinitialiser les filtres',
      exportData: 'Exporter les données',
      noData: 'Aucune donnée',
      bar: 'Barres',
      line: 'Ligne',
      pie: 'Camembert',
      scatter: 'Dispersion',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filtrer',
      filterByCategory: 'Filtrer par catégorie',
      selectAll: 'Tout sélectionner',
      clearAll: 'Tout effacer',
      searchCategories: 'Rechercher des catégories...',
      noCategories: 'Aucune catégorie trouvée',
      noData: 'Aucune donnée',
      devices: 'appareils',
      selected: 'Sélectionnés',
      category: 'catégorie',
      categories: 'catégories',
      more: 'de plus',
    },
    detailLevel: {
      label: 'Niveau de détail',
      units: {
        minutes: 'Minutes',
        minutesShort: 'min',
        day: 'Jour',
      },
    },
    dateRange: {
      startLabel: 'Date de début',
      endLabel: 'Date de fin',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Date',
        total: {
          production: 'Production totale :',
          consumption: 'Consommation totale :',
        },
        highestPeak: 'Pic le plus élevé :',
        calculatedPrice: {
          eur: 'Prix calculé (EUR) :',
          nok: 'Prix calculé (NOK) :',
        },
      },
    },
  },

  analytics: {
    session: {
      moreActions: "Plus d'actions",
      newSession: 'Nouvelle session',
      unsaved: 'Modifications non enregistrées',
      namePlaceholder: 'Nom de la session',
      deleteTitle: 'Supprimer la session ?',
      deleteDescription:
        "Cela supprime définitivement la session enregistrée et sa sélection d'appareils.",
      noSessions: 'Aucune session enregistrée',
      discardTitle: 'Abandonner les modifications non enregistrées ?',
      discardDescription:
        'La session actuelle comporte des modifications non enregistrées. Elles seront perdues si vous changez.',
    },
    notifications: {
      overlayMissingZone:
        "Aucune zone n'est configurée pour ce bâtiment. Utilisation de la valeur par défaut (NO1).",
      overlayMissingRate: 'Impossible de récupérer le taux de change',
      overlayFetchFailed: 'Impossible de charger les données de superposition',
      sessionSaved: 'Session enregistrée',
      sessionCreated: 'Session créée',
      sessionDeleted: 'Session supprimée',
      sessionSaveFailed: "Impossible d'enregistrer la session",
      sessionDeleteFailed: 'Impossible de supprimer la session',
      sessionsLoadFailed: 'Impossible de charger les sessions enregistrées',
      devicesLoadFailed: 'Impossible de charger les appareils',
      buildingsLoadFailed: 'Impossible de charger les bâtiments',
      readingsLoadFailed:
        "Impossible de charger les relevés d'un ou plusieurs appareils",
      nameRequired: "Donnez un nom à la session avant d'enregistrer",
      rangeTooWide:
        'Les périodes de plus de 7 jours sont lentes à cet intervalle. Passez à Quotidien pour de meilleures performances.',
    },
    title: 'Analyses en temps réel & KPI',
    pageTitle: 'Analytique',
    searchPlaceholder: 'Rechercher des appareils…',
    buttons: {
      toggleSidebar: 'Afficher/masquer la liste des appareils',
      showAll: 'Tout afficher',
      hideAll: 'Tout masquer',
      showTrends: 'Afficher les tendances',
      hideTrends: 'Masquer les tendances',
      clearAll: 'Tout effacer',
      export: 'Exporter',
    },
    exportMenu: {
      exportAsPNG: 'Exporter en PNG',
      exportAsCSV: 'Exporter en CSV',
    },
    thresholds: {
      max: 'Max :',
      min: 'Min :',
      aboveThreshold: 'Au-dessus du seuil',
      belowThreshold: 'En dessous du seuil',
    },
    timeAxis: {
      label: 'Axe temporel',
      actual: 'Temps réel',
      timeOfDay: 'Heure de la journée',
      dayOfWeek: 'Jour de la semaine',
      dayOfMonth: 'Jour du mois',
      bucket: 'Grouper par',
    },
    legend: {
      manage: 'Gérer',
      overlays: 'Superpositions',
      series: 'Séries',
      trends: 'Tendances',
      more: 'de plus',
    },
    overlay: {
      weatherAndElectricity: 'Météo & Électricité',
      none: 'Aucun',
      outsideTemperature: 'Température extérieure',
      elecPrice: 'Prix élec.',
      elecPriceFull: 'Prix élec. (€/kWh)',
      loadingData: 'Chargement des données...',
    },
    collab: {
      viewingSession: 'consulte cette session',
      updatedSession: 'a mis à jour cette session',
      deletedSession: 'a supprimé cette session',
      conflictTitle: "Quelqu'un a enregistré une version plus récente",
      conflictDescription:
        "Cette session a été enregistrée par quelqu'un d'autre pendant votre modification. Charger sa version (vos modifications seront perdues) ou l'écraser avec la vôtre.",
      loadTheirs: 'Charger sa version',
      overwrite: 'Écraser',
    },
    picker: {
      wholeBuilding: 'Bâtiment entier',
      noClimateSources: 'Aucun bâtiment avec des zones',
      noAveragesData: 'Pas encore de données climatiques',
      noIndoorSensors: "Le bâtiment n'a pas de capteurs intérieurs",
      inSession: 'Dans la session',
      searchBuildings: 'Rechercher des bâtiments…',
      noBuildingsMatch: 'Aucun bâtiment ne correspond',
      noWeatherData: 'Pas encore de données météo',
    },
    devices: {
      noDevicesMatch: 'Aucun appareil correspondant',
      unnamedDevice: 'Appareil sans nom',
      noDevicesSelected: 'Aucun appareil sélectionné',
      devicesFound: 'appareils trouvés',
      noDevicesMatchSearch: 'Aucun appareil ne correspond à votre recherche',
      deviceSelected: 'appareil sélectionné',
      devicesSelected: 'appareils sélectionnés',
      shown: 'affichés',
      total: 'total',
    },
    chart: {
      zoomHint: 'Zoom actif (double-cliquez pour réinitialiser)',
      loadingChartData: 'Chargement des données du graphique...',
      addDevicesToVisualize:
        'Ajouter des appareils pour visualiser les données',
    },
    liveEvents: {
      title: 'Événements en direct',
      events: 'événements',
      waitingForEvents: "En attente d'événements…",
    },
    modal: {
      weatherIntervalHint: 'Les données météo ont une résolution horaire',
      deviceSettings: "Paramètres de l'appareil",
      addDevices: 'Ajouter des appareils',
      clear: 'Effacer',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      samplingInterval: "Intervalle d'échantillonnage",
      dataAggregationGranularity: "Granularité d'agrégation des données",
      startMustBeBeforeEnd: 'Le début doit être avant la fin',
      intervals: {
        fiveMinutes: '5 minutes',
        fifteenMinutes: '15 minutes',
        oneHour: '1 heure',
        daily: 'Quotidien',
      },
    },
    connectionStatus: {
      error: 'ERREUR',
      connected: 'CONNECTÉ',
      connecting: 'CONNEXION',
      disconnected: 'DÉCONNECTÉ',
    },
  },

  eosDashboard: {
    headerTitle: 'Aperçu de l’énergie',
    energyKnowledge: {
      title: 'Analyse énergétique',
      lastMonth: 'Mois dernier',
    },
    building: 'Bâtiment',
    selectBuilding: 'Sélectionner un bâtiment',
    outdoorTemperature: 'Température extérieure',
    noData: 'N/D',
    electricityPrice: 'Prix de l’électricité',
    electricityPrices: 'Prix de l’électricité',
    noPriceData: 'Aucune donnée de prix disponible.',
    electricityConsumption: 'Consommation d’électricité',
    baseline: 'Référence',
    viewLabel: 'Vue :',
    aggregated: 'Agrégée',
    meteringPoint: 'Point de comptage :',
    individualTitle: 'Points de comptage individuels',
    eosSourcesTitle: 'Appareils EOS individuels',
    footprint: 'Empreinte CO₂ (Réduction)',
    co2Footprint: 'Empreinte CO₂',
    consumption: 'Consommation',
    avgMaxKwp: 'Puissance crête moyenne (kWp)',
    higher: 'Plus élevé',
    lower: 'Plus bas',
    normal: 'Normal',
    priceWord: 'prix',
    vsAverage: 'Par rapport à la moyenne',

    baselineChart: {
      total: 'Total',
      average: 'Moyenne',
      leftAxis: 'kWh (Consommation)',
      rightAxis: 'kWp (Puissance max. moyenne)',
      co2Avg: 'CO₂ moyen',
      missingData: 'Données manquantes',
      missingDataDescription: 'Valeurs manquantes pour ce mois',
    },
    energyLabel: {
      title: 'Étiquette énergétique dynamique',
      withoutSastech: 'Étiquette officielle',
      withSastech: 'Étiquette dynamique',
      deliveredEnergy: 'Énergie livrée calculée',
      insufficientData:
        "Seulement {months} mois de données disponibles. L'étiquette peut ne pas être représentative.",
      noFloorArea: "La surface utile nette n'est pas définie pour ce bâtiment.",
      noBuildingCategory:
        "La catégorie de bâtiment n'est pas définie pour ce bâtiment.",
      fossilFuelShare: 'Part d’électricité/mazout/gaz',
      reduction: 'Réduction',
      floorArea: 'Surface habitable',
      annualConsumption: 'Annuel',
      energyGrade: 'Classe énergétique',
      labels: {
        A: 'Très économe en énergie',
        B: 'Économe en énergie',
        C: 'Efficacité modérée',
        D: 'En dessous de la moyenne',
        E: 'Faible efficacité',
        F: 'Très faible efficacité',
        G: 'Moins efficace',
      },
    },
    kpiSection: {
      noChange: '0.0',

      units: {
        kWh: 'kWh',
        kg: 'kg',
        kgCo2: 'kg CO₂',
        krPerKWh: 'kr/kWh',
        degC: '°C',
      },

      trend: {
        increaseSign: '+{percent}%',
        decreaseSign: '-{percent}%',
        neutral: '0.0',
        aboveAverage: 'Au-dessus',
        belowAverage: 'En dessous',
        atAverage: 'À',
        averageThisPeriod: 'moyenne de cette période',
      },

      consumption: {
        title: 'Consommation totale',
        value: '{value} {unit}',
        subtitle: {
          increased: 'Augmenté de {delta} {unit}',
          reduced: 'Réduit de {delta} {unit}',
          noChange: 'Aucun changement de consommation',
          noBaseline: 'Aucune donnée de référence disponible',
        },
        detail: 'Consommation d’énergie sur les {periodLabel}',
      },

      co2: {
        title: 'Empreinte carbone totale',
        value: '{value} {unit}',
        subtitle: {
          reduced: 'Réduction de {delta} {unit}',
          increased: 'Augmentation de {delta} {unit}',
          noChange: 'Aucun changement des émissions',
          noBaseline: 'Aucune donnée de référence disponible',
        },
        detail: 'Empreinte carbone sur les {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Consommation ajustée en degrés-jours',
      },

      estate: {
        title: 'Bâtiments et sources',
        value: '{count} bâtiments',
        subtitle: '{count} total des sources',
        detail: 'Actuellement {count} appareils actifs',
      },

      price: {
        title: 'Prix actuel',
        value: '{value} {unit}',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Prix de l’électricité en ce moment',
      },

      temperature: {
        title: 'Température',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Conditions météorologiques actuelles',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title:
          'Comparaison de la consommation - année dernière vs année en cours',
        baseLineLabel: 'Référence',
        peakHourlyLabel: 'Pic le plus élevé',
      },
      consumptionSavings: {
        title: `Économies de consommation - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Total',
      totalEnergyConsumption: 'Consommation totale d’énergie',
      totalElectricityConsumption: 'Consommation totale d’électricité',
      energyConsumption: 'Consommation d’énergie',
      electricityConsumption: 'Consommation d’électricité',
      noDataForSelectedPeriod: 'Aucune donnée pour la période sélectionnée',
      meteringPointTitle: 'Point de comptage : {id}',
      sourceTitle: 'Source : {id}',
      unknownLabel: 'Inconnu',
      unknownIdLabel: 'ID inconnu',
      powerFactorLabel: 'Facteur de puissance Cos φ',
      powerFactorWarning:
        'Un facteur de puissance inférieur à 0,95 peut entraîner des pénalités tarifaires',
      renameDialog: {
        title: 'Renommer le point de comptage',
        label: 'Nom d’affichage',
        helpTextPrefix: 'ID original du point de comptage',
      },
      errors: {
        loadAggregatedData: 'Échec du chargement des données agrégées',
        loadFilteredData: 'Échec du chargement des données filtrées',
        fetchDisplayName: 'Échec de la récupération du nom d’affichage',
        invalidDisplayName: 'Veuillez fournir un nom d’affichage valide',
        renameFailed: 'Échec du renommage de l’appareil EOS',
        renameUnknown:
          'Une erreur est survenue lors du renommage de l’appareil EOS',
        noDataToExport: 'Aucune donnée à exporter',
        exportFailedTitle: 'Échec de l’exportation',
        exportFailedPrefix: 'Échec de l’exportation des données',
        unknownError: 'Erreur inconnue',
        enterValidDisplayName: 'Veuillez saisir un nom d’affichage valide',
        validationErrorTitle: 'Erreur de validation',
      },
      tooltip: {
        electricityElhub: 'Électricité',
        reactiveEnergy: 'Énergie réactive',
        buildingsLabel: 'Bâtiments',
        meteringPointsLabel: 'Points de mesure',
        districtHeating: 'Chauffage urbain',
        solarPv: 'Énergie solaire produite',
        exportedElectricity: 'Électricité exportée',
      },
    },
    co2BarChart: {
      baseline: 'Référence',
      currentValues: 'Valeurs actuelles',
      co2Emissions: 'Émissions de CO₂',
      dailyEmissions: 'Émissions quotidiennes',
      monthlyEmissions: 'Émissions mensuelles',
      months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      goal: 'Objectif',
    },
    chartMenu: {
      rename: 'Renommer',
      exportExcel: 'Exporter Excel',
      exportCSV: 'Exporter CSV',
    },
    periodOptions: {
      '3days': {
        label: '3 derniers jours',
        mobileLabel: '3 jours',
        chartLabel: '3 jours',
      },
      '30days': {
        label: '30 derniers jours',
        mobileLabel: '30 jours',
        chartLabel: '30 jours',
      },
      '3months': {
        label: '3 derniers mois',
        mobileLabel: '3 mois',
        chartLabel: '3 mois',
      },
    },
    chartSubtitle: {
      today: 'Total pour aujourd’hui',
      oneDay: 'Total pour 1 jour',
      days: 'Total pour {days} jours',
      oneWeek: 'Total pour 1 semaine',
      weekAndDays: 'Total pour 1 semaine et {days} jour(s)',
      weeks: 'Total pour {weeks} semaines',
      weeksAndDays: 'Total pour {weeks} semaines et {days} jour(s)',
      months: 'Total pour {months} mois',
      monthsAndDays: 'Total pour {months} mois et {days} jour(s)',
      monthsAndWeeks: 'Total pour {months} mois et {weeks} semaine(s)',
    },
    datePicker: {
      startLabel: 'Début',
      endLabel: 'Fin',
    },
    weatherTemperature: {
      noData: 'Aucune donnée météo disponible',
      headerTitle: 'Prévisions météo',
      headerSubtitle: 'Prévision',
      tooltip: {
        conditions: 'Conditions',
        temperature: 'Température',
        wind: 'Vent',
        windDirection: 'Direction du vent',
        pressure: 'Pression',
        cloudCover: 'Couverture nuageuse',
        fog: 'Brouillard',
        uvIndex: 'Indice UV',
        precipitation: 'Précipitations pour la prochaine heure',
      },
      stats: {
        min: 'Min',
        avg: 'Moy.',
        max: 'Max',
        current: 'Actuel',
      },
    },
    tempTrend: {
      stable: 'Température extérieure stable',
      graduallyRising: 'Température en hausse progressive',
      graduallyFalling: 'Température en baisse progressive',
      rising: 'Température extérieure en hausse',
      falling: 'Température extérieure en baisse',
    },
    noDataForPeriod: 'Aucune donnée énergétique pour la période sélectionnée',
    totalEnergy: 'Énergie totale',
    filters: {
      noMatch: 'Aucun nœud ne correspond à toutes les catégories sélectionnées',
    },
    staleData: {
      warningText: "les données d'hier ne sont pas disponibles",
      showingDataFrom: 'Affichage des données du',
    },
    sankey: {
      noData: 'Aucune donnée Sankey disponible.',
      searchNodes: 'Rechercher des nœuds...',
      selectedNodes: 'Nœuds sélectionnés',
      csvValue: 'Valeur (kWh)',
      csvDeviceId: 'ID appareil',
    },
  },

  superSettings: {
    securityLog: {
      title: 'Journal de sécurité',
      levelBadge: 'Niveau 10',
      intro:
        "Connexions, modifications, accès aux données et utilisation de l'API pour tous les clients. Les connexions, modifications et accès aux données sont conservés 90 jours, l'utilisation 30 jours.",
      error: "Le journal de sécurité n'a pas pu être chargé.",
      tabs: {
        overview: 'Aperçu',
        logins: 'Connexions',
        changes: 'Modifications',
        reads: 'Accès aux données',
        usage: 'Utilisation',
        sessions: 'Sessions',
      },
      filters: {
        period: 'Période',
        last24h: 'Dernières 24 heures',
        last7d: '7 derniers jours',
        last30d: '30 derniers jours',
        last90d: '90 derniers jours',
        custom: 'Personnalisée',
        vendor: 'Client',
        allVendors: 'Tous les clients',
        exportCsv: 'Exporter en CSV',
        refresh: 'Actualiser',
      },
      totals: {
        logins: 'Connexions',
        loginsHint: '{users} utilisateurs, {ips} IP',
        reads: 'Accès aux données',
        readsHint: '{users} utilisateurs',
        readsTooltip:
          'Consultations des listes d’utilisateurs, listes de clients, leads et journaux',
        failedLogins: 'Connexions échouées',
        rateLimitedHint: '{count} bloquées par la limite de débit',
        changes: 'Modifications',
        deletesHint: '{count} suppressions',
        accessChanges: "Modifications d'accès",
        accessHint: 'Niveaux, accès clients, Entra ID',
        requests: 'Requêtes API',
        requestsHint: '{users} utilisateurs actifs',
        compromised: 'Peut-être compromis',
        compromisedHint: 'Comptes à vérifier',
        unknownOutcome:
          "{count} connexions antérieures à l'enregistrement des résultats sont comptées à part.",
        truncated:
          'La période est longue ; seules les 20 000 premières entrées ont été vérifiées.',
      },
      attention: {
        title: 'À examiner',
        empty: 'Rien à examiner sur cette période.',
        high: 'Élevé',
        medium: 'Moyen',
        low: 'Faible',
        showMore: 'Tout afficher ({count})',
      },
      compromised: {
        title: 'Comptes peut-être compromis',
        empty: 'Aucun compte ne montre de signe de compromission.',
        help: "Une utilisation qu'aucune personne ne pourrait produire, ou une session utilisée depuis plusieurs endroits à la fois.",
      },
      chart: {
        title: 'Connexions par jour',
        success: 'Réussies',
        failed: 'Échouées',
        rateLimited: 'Limitées',
      },
      sensitive: {
        title: "Dernières modifications d'accès",
        empty: "Aucune modification d'accès sur cette période.",
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} connexions échouées pour {who}, puis une connexion réussie',
        failedLogins: '{count} connexions échouées pour {who}',
        failedLoginsIp:
          '{count} connexions échouées depuis {ip}, sur {accounts} comptes',
        rateLimited: '{count} tentatives de connexion bloquées pour {who}',
        newIp: "{who} s'est connecté depuis une nouvelle adresse IP ({ip})",
        levelRaised:
          '{who} est passé du niveau {old} au niveau {new}, par {by}',
        accessChange: 'Accès modifié pour {who} ({fields}) par {by}',
        userDeleted: '{who} a été supprimé par {by}',
        massDelete: '{who} a supprimé {count} enregistrements en 10 minutes',
        requestBurst: '{who} a fait {count} requêtes en une minute',
        alwaysOn: '{who} a été actif {count} heures en une journée',
        parallelLocations:
          '{who} a été utilisé depuis {count} adresses IP en même temps',
        parallelDevices:
          '{who} a été utilisé depuis {count} appareils en même temps',
        robotRhythm:
          '{who} a envoyé des requêtes à un rythme régulier de machine pendant {count} minutes',
        changeBurst: '{who} a fait {count} modifications en 10 minutes',
        vendorHopping: '{who} a travaillé chez {count} clients en une heure',
        readBurst:
          '{who} a consulté des données critiques {count} fois en 10 minutes',
        unknown: 'Alerte inconnue',
        someone: 'compte inconnu',
        occurrences: '{count} fois sur la période',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Connexion après de nombreux échecs',
        failedLogins: 'Nombreuses connexions échouées',
        failedLoginsIp: 'Adresse IP en échec',
        rateLimited: 'Limité',
        newIp: 'Nouvelle adresse IP',
        levelRaised: 'Niveau relevé',
        accessChange: 'Accès modifié',
        userDeleted: 'Utilisateur supprimé',
        massDelete: 'Suppression en masse',
        requestBurst: 'Pic de requêtes',
        alwaysOn: 'Toujours actif',
        parallelLocations: 'Plusieurs lieux à la fois',
        parallelDevices: 'Plusieurs appareils à la fois',
        robotRhythm: 'Rythme de machine',
        changeBurst: 'Pic de modifications',
        vendorHopping: 'Changements de client',
        readBurst: 'Lecture massive',
      },
      logins: {
        time: 'Heure',
        outcome: 'Résultat',
        method: 'Méthode',
        account: 'Compte',
        vendor: 'Client',
        ip: 'Adresse IP',
        device: 'Appareil',
        allOutcomes: 'Tous les résultats',
        allFailures: 'Tous les échecs',
        allMethods: 'Toutes les méthodes',
        searchEmail: 'Rechercher un e-mail',
        searchIp: 'Adresse IP',
        filterByIp: 'Afficher les connexions depuis cette IP',
        filterByAccount: 'Afficher les connexions de ce compte',
        empty: 'Aucune connexion ne correspond aux filtres.',
      },
      outcomes: {
        success: 'Réussie',
        wrong_password: 'Mauvais mot de passe',
        unknown_user: 'Utilisateur inconnu',
        inactive: 'Désactivé',
        invalid_input: 'Saisie invalide',
        rate_limited: 'Limité',
        unknown_vendor: 'Tenant inconnu',
        invalid_session: 'Session invalide',
        unknown: 'Non enregistré',
      },
      methods: {
        password: 'Mot de passe',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Heure',
        action: 'Action',
        collection: 'Collection',
        record: 'Enregistrement',
        by: 'Par',
        vendor: 'Client',
        endpoint: 'Requête',
        history: 'Historique',
        allActions: 'Toutes les actions',
        create: 'Créé',
        update: 'Mis à jour',
        delete: 'Supprimé',
        collectionPlaceholder: 'Collection, par ex. users',
        fieldPlaceholder: 'Champ, par ex. level',
        empty: 'Aucune modification ne correspond aux filtres.',
        filterByUser: 'Afficher les modifications de cet utilisateur',
      },
      reads: {
        time: 'Heure',
        user: 'Utilisateur',
        area: 'Quoi',
        vendor: 'Client',
        ip: 'Adresse IP',
        device: 'Appareil',
        allAreas: 'Tout sauf le journal de sécurité',
        everything: 'Tout, y compris le journal de sécurité',
        searchIp: 'Adresse IP',
        filterByUser: 'Afficher les consultations de cet utilisateur',
        filterByIp: 'Afficher les consultations depuis cette IP',
        empty: 'Aucune consultation ne correspond aux filtres.',
        note: 'Consultations des listes d’utilisateurs, listes de clients, leads et journaux, conservées 90 jours.',
      },
      readAreas: {
        vendors: 'Liste des clients',
        users: 'Liste des utilisateurs',
        alarmUsers: "Utilisateurs d'alarme",
        energyLabelLeads: 'Leads de DPE',
        enerskyAccess: 'Accès Enersky',
        feedback: 'Retours',
        requestLogs: 'Journaux des requêtes',
        securityLog: 'Journal de sécurité',
        other: 'Autre',
      },
      usage: {
        user: 'Utilisateur',
        requests: 'Requêtes',
        peak: 'Pic par minute',
        activeMinutes: 'Minutes actives',
        ips: 'IP',
        devices: 'Appareils',
        vendors: 'Clients',
        flags: 'Signalements',
        flaggedOnly: 'Seulement les utilisateurs signalés',
        compromisedBadge: 'Peut-être compromis',
        empty: "Aucune utilisation de l'API sur cette période.",
        note: "L'utilisation de l'API est conservée 30 jours.",
      },
      sessions: {
        user: 'Utilisateur',
        rights: 'Droits',
        method: 'Méthode',
        ip: 'Adresse IP',
        device: 'Appareil',
        started: 'Connecté',
        lastSeen: 'Vu pour la dernière fois',
        status: 'Statut',
        open: 'Ouverte',
        revoked: 'Révoquée',
        expired: 'Expirée',
        idle: 'Inactive',
        level: 'Niveau {level}',
        tenants: '+{count} clients',
        openOnly: 'Seulement les sessions ouvertes',
        revoke: 'Révoquer',
        revokeTitle: 'Révoquer cette session ?',
        revokeText: 'La session de {who} ({method}, {ip}) est terminée.',
        cancel: 'Annuler',
        revokeFailed: "La session n'a pas pu être révoquée.",
        empty: 'Aucune session ne correspond aux filtres.',
        note: 'Une session se termine {absolute} heures après la connexion, ou après {idle} heures sans utilisation. Les sessions sont conservées 90 jours.',
        notEnforced:
          "Les sessions sont enregistrées mais pas encore appliquées. Révoquer marque une session comme terminée ; l'utilisateur est déconnecté une fois l'application activée.",
      },
      history: {
        title: "Historique de l'enregistrement",
        empty: 'Aucune modification enregistrée pour cet enregistrement.',
        close: 'Fermer',
        open: "Afficher l'historique de cet enregistrement",
      },
    },
    areasMenu: {
      securityLog: 'Journal de sécurité',
      createDashboard: 'Créer tableau de bord',
      feedback: 'Commentaires',
      projects: 'Projets',
      icMeter: 'Compteur IC',
      lakeSensors: 'Capteurs de lac',
      eosDevices: 'Appareils EOS',
      deviceMapping: 'Cartographie des appareils',
      energyLabeling: 'Étiquetage énergétique',
      alarmSystems: 'Systèmes d’alarme',
      enerskyAccess: 'Accès Enersky',
    },
    dataQuality: {
      title: 'Inspecteur de qualité des données',
      subtitle:
        'Vue en temps réel de tous les groupes de capteurs et de l’état des données des appareils.',
      noLakes: 'Aucun groupe de capteurs trouvé',
      noDevices: 'Aucun appareil',
      allReporting: 'Tous en ligne',
      missing: 'manquants',
      device: 'appareil',
      devices: 'appareils',
      missingData: 'Données manquantes',
    },
    createDashboard: {
      header: 'Nouveau tableau de bord client',
      sections: {
        companyDetails: 'Informations sur l’entreprise',
        address: 'Adresse',
        contactDetails: 'Coordonnées',
      },
      fields: {
        companyName: 'Nom de l’entreprise',
        organizationNumber: 'Numéro d’enregistrement',
        street: 'Rue',
        city: 'Ville',
        postcode: 'Code postal',
        country: 'Pays',
        email: 'E-mail',
        phoneNumber: 'Numéro de téléphone',
        timezone: 'Fuseau horaire du client',
      },
      helperText: {
        organizationNumber: 'Numéro d’enregistrement de l’entreprise',
        timezone: 'Sélectionnez le fuseau horaire du client',
      },
      buttons: {
        cancel: 'Annuler',
        createClient: 'Créer le client',
      },
    },

    sastechFeedback: {
      title: 'Retour Sastech',
      table: {
        title: 'Messages de retour',
        message: 'Message',
        actions: 'Actions',
        resolved: 'Résolu',
        resolvedBy: 'par',
        unResolved: 'Non résolu',
        filter: 'Filtre',
        developerFeedback: 'Retour du développeur',
        comment: 'Commentaire',
        assignDeveloper: 'Attribuer un développeur',
        suggestedAction: 'Action suggérée',
        tags: 'Tags',
        noTagsProvided: 'Aucun tag fourni',
        vote: 'Voter',
        resolvedTicketsThisWeek: 'Tickets résolus cette semaine',
        last7Days: '7 derniers jours',
        newTicketsThisWeek: 'Nouveaux tickets cette semaine',
        featureTicketsThisWeek: 'Tickets de fonctionnalité cette semaine',
        bugTicketsThisWeek: 'Tickets de bug cette semaine',
        resolvedTickets: 'Tickets résolus',
      },
      buttons: {
        resolve: 'Résoudre',
        save: 'Enregistrer la réponse',
      },
      confirm: {
        resolve: 'Êtes-vous sûr de vouloir marquer ce message comme résolu ?',
        delete: 'Êtes-vous sûr de vouloir supprimer ce message ?',
      },
      details: {
        browserInfo: 'Infos du navigateur :',
        device: 'Appareil',
        operatingSystem: 'Système d’exploitation',
        path: 'Chemin',
        resolution: 'Résolution',
        na: 'n.d.',
        screenshotAlt: 'capture d’écran',
      },
    },
    alarmSystems: {
      titleEdit: 'Modifier le système d’alarme',
      accordion: {
        details: "Détails de l'alarme",
        heartbeat: 'Détails du heartbeat',
        notification: 'Détails de notification',
        connectedDevices: "Alarmes d'appareils connectés",
      },
      fields: {
        systemName: 'Nom du système d’alarme',
        description: 'Description',
        location: 'Emplacement',
        key: 'Clé',
      },
      heartbeat: {
        explanation:
          'L’intervalle de heartbeat est le temps en secondes entre chaque signal envoyé par le système d’alarme au serveur. Ce signal indique que le système est actif et fonctionne correctement. Si le serveur ne reçoit pas de signal dans le délai imparti, cela peut indiquer un problème.',
        monitor: 'Moniteur de heartbeat',
        hours: 'Heures',
        minutes: 'Minutes',
        seconds: 'Secondes',
      },
      notification: {
        type: 'Type de notification',
        selectType: 'Sélectionner le type de notification',
        options: {
          email: 'Email',
          sms: 'SMS',
        },
        recipient: 'Destinataire de notification',
        recipients: 'Destinataires de notification',
        selectUser: 'Sélectionner un utilisateur',
        orAddManually: 'Ou ajouter un email ou numéro de mobile manuellement :',
        addRecipient: 'Ajouter un destinataire',
        contact: 'Email / numéro de mobile',
        minimumSeverity: 'Gravité minimale',
        severityLevels: {
          1: 'Info',
          2: 'Avertissement',
          3: 'Mineure',
          4: 'Majeure',
          5: 'Critique',
        },
        errors: {
          empty: 'Le destinataire ne peut pas être vide',
          duplicate: 'Ce destinataire est déjà présent',
          invalidEmail: "Format d'email invalide",
          selectTypeFirst:
            "Veuillez d'abord sélectionner le type de notification",
          enterEmail: 'Veuillez saisir une adresse email',
          enterMobile: 'Veuillez saisir un numéro de mobile',
        },
      },
      connectedDevices: {
        empty:
          "Aucune alarme d'appareil n'est connectée à ce système d'alarme.",
        unnamed: 'Alarme sans nom',
      },
      titleCreate: "Créer un système d'alarme",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce système d'alarme ?",
      list: {
        new: 'Nouveau',
        search: 'Rechercher...',
        empty: "Aucun système d'alarme trouvé",
      },
      updatedSuccess: "Système d'alarme mis à jour avec succès",
      createdSuccess: "Système d'alarme créé avec succès",
      deletedSuccess: "Système d'alarme supprimé avec succès",
      updateError: "Erreur lors de la mise à jour du système d'alarme",
      createError: "Erreur lors de la création du système d'alarme",
      deleteError: "Erreur lors de la suppression du système d'alarme",
      fetchError: "Erreur lors de la récupération des systèmes d'alarme",
      fetchLogsError: "Erreur lors de la récupération des journaux d'alarme",
    },
    enerskyAccess: {
      list: {
        header: 'Enregistrements d’accès Enersky',
        description:
          'Gérez l’accès au partage de données et le statut des contrats des clients',
        tableTitle: 'Enregistrements d’accès',
        addButton: 'Créer un enregistrement',
        emptyState: 'Aucun enregistrement trouvé.',
        searchPlaceholder: 'Rechercher des enregistrements existants…',
        backButton: 'Retour aux enregistrements',
      },
      columns: {
        vendor: 'Fournisseur',
        customer: 'Client',
        status: 'Statut',
      },
      validation: {
        missingVendor: 'Le fournisseur est obligatoire.',
        missingFirstName: 'Le prénom est obligatoire.',
        missingLastName: 'Le nom de famille est obligatoire.',
        missingEmail: 'Une adresse e-mail valide est requise.',
        missingCompanyName:
          'Le nom de l’entreprise est obligatoire pour les clients professionnels.',
        missingOrganizationNumber: 'Le numéro d’organisation est obligatoire.',
        missingNationalId:
          'Le numéro d’identification nationale est obligatoire.',
      },
      feedback: {
        save: {
          missingInfoTitle: 'Informations manquantes',
          missingInfoMessage: 'Veuillez remplir tous les champs obligatoires.',
          createSuccessTitle: 'Enregistrement créé',
          createSuccessMessage:
            'Enregistrement créé et e-mail de contrat envoyé.',
          updateSuccessTitle: 'Mis à jour',
          updateSuccessMessage: 'Coordonnées mises à jour.',
          errorTitle: 'Erreur',
          errorMessage: 'Échec de l’enregistrement.',
          duplicateEndUser: 'Ce client existe déjà dans Enersky.',
        },

        refresh: {
          mpidsTitle: 'Abonnements actualisés',
          mpidsMessage: 'Les statuts des MPID ont été mis à jour.',
          statusTitle: 'Statut actualisé',
          statusMessage:
            'Le statut de l’enregistrement et les MPID ont été mis à jour.',
          errorTitle: 'Erreur',
          errorMessage: 'Échec de l’actualisation des données.',
        },

        resend: {
          title: 'E-mail envoyé',
          message: 'L’e-mail du contrat a été renvoyé au client.',
          errorTitle: 'Erreur',
          errorMessage: 'Échec du renvoi de l’e-mail du contrat.',
        },

        history: {
          title: 'Demande de données historiques mise en file d’attente',
          message: 'Données mises en file d’attente.',
          errorTitle: 'Erreur',
          errorMessage: 'Échec de la mise en file d’attente des données.',
        },
        delete: {
          successTitle: 'Enregistrement supprimé',
          successMessage: "L'enregistrement d'accès Enersky a été supprimé.",
          errorTitle: 'Erreur',
          errorMessage: "Échec de la suppression de l'enregistrement.",
        },
      },
      editEnerskyAccess: {
        labels: {
          basicInfo: 'Informations de base',
          vendor: 'Fournisseur',
          firstName: 'Prénom',
          lastName: 'Nom de famille',
          email: 'E-mail',
          companyName: "Nom de l'entreprise",
          privatePerson: 'Particulier',
          nationalId: 'Numéro d’identification nationale',
          organizationNumber: 'Numéro d’organisation',
          systemInfo: 'Informations sur l’enregistrement d’accès Enersky',
          accessUrl: 'URL d’accès',
          requestId: 'Identifiant de la demande',
          errorMessage: 'Message d’erreur',
          mpidSection: 'Points de comptage (MPID)',
          mpid: 'MPID',
          meterNumber: 'Numéro de compteur',
          address: 'Adresse',
          description: 'Description',
          priceArea: 'Zone tarifaire',
          status: 'Statut',
          actions: 'Actions',
          deleteConfirmMessage:
            'Êtes-vous sûr de vouloir supprimer cet enregistrement ?',
        },

        buttons: {
          resendLink: 'Renvoyer le lien',
          refreshSubscriptions: 'Actualiser les abonnements',
          readHistoricalData: 'Lire les données historiques',
        },

        status: {
          unknown: 'Statut inconnu',
        },

        none: 'Aucun',
        unknownError: 'Erreur inconnue',
      },
      status: {
        Pending: 'En attente',
        'Contract email sent': 'E-mail du contrat envoyé',
        'Contract link requested': 'Lien du contrat demandé',
        Completed: 'Terminé',
        Error: 'Erreur',
        Unknown: 'Statut inconnu',
      },
    },

    chirpStackKeys: {
      title: 'Fichiers de clés importés',
      addButton: 'Importer des clés',
      columns: {
        fileName: 'Nom du fichier',
        uploadedAt: 'Téléversé le',
        importedCount: 'Nombre importé',
      },
      importFile: 'Importer un fichier de clés ChirpStack',
      preview: {
        title: 'Aperçu',
        noRows: 'Aucune ligne à afficher.',
        close: 'Fermer',
        cancel: 'Annuler',
        confirm: 'Confirmer l’importation',
      },
      feedback: {
        loadError: 'Échec du chargement des fichiers',
        previewError: 'Échec de l’aperçu',
        invalidExcel: 'Fichier Excel invalide.',
        missingFile: 'Fichier original manquant, veuillez réessayer',
        importSuccess: 'Importation réussie',
        importError: 'Échec de l’importation',
      },
    },

    icMeterData: 'Données du compteur IC',
    buildingSensorData: 'Données capteurs de bâtiment',
    eosSensorData: 'Données capteur EOS',
    protocol: 'Protocole de communication',
  },
  buildings: {
    sidebar: {
      modifyToggle: 'Modifier',
      editBuildingTitle: 'Modifier le bâtiment',
      buildingOverviewTitle: 'Aperçu du bâtiment',
      editZoneTitle: 'Modifier la zone',
      outdoorTemperatureTitle: 'Température extérieure',
      indoorClimateTitle: 'Climat intérieur',
      buildingTemperature: 'Température du bâtiment',
      floorTemperature: 'Température de l’étage',
      outdoorTempLabel: 'Temp. ext. :',
      electricityPriceLabel: "Prix d'électricité :",
      energyLabel: 'Étiquette énergie :',
      noData: 'Aucune donnée',
      aspaTitle: 'Consigne ASPA',
      zoneFloors: {
        selectFloorLabel: 'Sélectionner étage de zone :',
        selectBuildingFloorLabel: 'Sélectionner étage du bâtiment :',
        changeFloor: '- Changer d’étage -',
        addFloor: 'Ajouter un étage',
        groundFloor: 'Rez-de-chaussée',
      },
    },
    aspa: {
      title: 'Paramètres ASPA',
      noPayload: 'Aucune donnée ASPA trouvée pour ce bâtiment.',
      avgTemp: 'Température moyenne',
      acrossAllZones: 'Toutes zones confondues',
      highestZoneTemp: 'Temp. zone la plus élevée',
      peakZoneReading: 'Relevé de zone maximal',
      lastUpdated: 'Dernière mise à jour',
      payloadsReceived: 'données reçues',
      setpointOverview: 'Aperçu des consignes',
      hourView: 'Vue sur 24 heures',
      hourOfDay: 'Heure de la journée',
      dailySetpoint: 'Consigne journalière (°C)',
      liveSetpoint: 'Consigne en direct (°C)',
      avg: 'Moy.',
      peak: 'Max',
      trends: 'Tendances',
      temperature: 'Température',
      humidity: 'Humidité',
      noTrendData: 'Aucune donnée de tendance.',
      recommendations: 'Recommandations',
      noRecommendations: 'Aucune recommandation trouvée.',
      actionKeys: {
        cool: 'Refroidissement',
        coolingLevel: 'Niveau de refroidissement',
        preCool: 'Pré-refroidissement',
        heat: 'Chauffage',
        heatingLevel: 'Niveau de chauffage',
        preHeat: 'Préchauffage',
      },
      items: 'éléments',
      on: 'Activé',
      off: 'Désactivé',
      samples: 'échantillons',
      trendPeriod: 'Dernières 2 heures',
    },
    details: {
      header: 'Détails du bâtiment',
      form: {
        buildingName: 'Nom du bâtiment',
        active: 'Actif',
        buildingInformation: 'Informations sur le bâtiment',
        buildingType: 'Type de bâtiment (norme NS)',
        buildingCategory: 'Catégorie de bâtiment',
        constructionYear: 'Année de construction',
        numberOfFloors: 'Nombre d’étages',
        netUsableFloorArea: 'Surface utile nette (m²)',
        gridRegion: 'Région réseau',
        selectGridRegion: '- Sélectionner région -',
        mix: 'Mix CO₂',
        addressAndGps: 'Adresse & GPS',
        street: 'Rue',
        street2: 'Rue 2',
        postCode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        latitude: 'Latitude',
        longitude: 'Longitude',
        fetchGps: 'Obtenir GPS',
        fillStreetCityError:
          'Veuillez remplir Rue et Ville pour récupérer les coordonnées GPS.',
        requiredAddressFields:
          'À renseigner avant l’enregistrement : {fields}.',
        searchCountry: 'Rechercher un pays',
        floorNumber: 'N° d’étage',
        preferredCurrency: 'Devise préférée',
        climateGoalPercentage: 'Pourcentage de l’objectif climatique',
        changeModel: 'Changer le modèle du bâtiment',
        defaultStartingFloor: 'Étage de départ',
        startingViewHint:
          'Faites pivoter, déplacez et zoomez l’aperçu pour définir la vue d’ouverture du bâtiment.',
        matrikkelData: {
          title: 'Données Matrikkel',
          error: 'Échec de la récupération des données Matrikkel',
          errorTitle: 'Erreur',
          matrikkelId: 'ID Matrikkel',
          cadastralNumber: 'Numéro cadastral',
          propertyUnitNumber: 'Numéro d’unité de propriété',
          sectionNumber: 'Numéro de section',
          unitNumber: 'Unités',
          leaseholdNumber: 'Numéro de bail',
          municipalityName: 'Nom de la commune',
          municipalityNumber: 'Numéro de la commune',
          success: 'Succès',
          successTitle: 'Données Matrikkel récupérées',
          fetchMatrikkelData: 'Récupérer les données Matrikkel',
          buildingNumber: 'Numéro du bâtiment',
          errorMissing: 'Champs d’adresse requis manquants',
          errorTooMany: 'Trop d’adresses trouvées',
          errorNotFound: 'Aucune adresse trouvée',
          unitId: 'ID de l’unité',
          noUnitIdFound:
            'Aucune unité trouvée à cette adresse. Veuillez vérifier l’adresse sur seeiedom.no et réessayer.',
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Section',
          fetchedFromMatrikkel: 'Récupéré depuis le matrikkel',
          overrideButton: 'Remplacer le bruksenhet',
          overrideSectionButton: 'Remplacer la section',
          addButton: 'Ajouter un bruksenhet',
          addSectionButton: 'Ajouter une section',
          manualWarning:
            'Uniquement nécessaire si les données matrikkel sont manquantes ou incorrectes.',
          buildingType: 'Type de bâtiment',
        },
      },
      baseline: {
        title: 'Référence',
        recalcButton: 'Recalculer la référence',
        confirmRecalculate: 'Voulez-vous vraiment recalculer la référence ?',
        success: 'Référence recalculée avec succès',
        error: 'Échec du recalcul de la référence',
        subscriptions: {
          title: 'Abonnements Elhub',
          loading: 'Chargement des abonnements…',
          emptyState: 'Aucun abonnement. Ajoutez-en un ci-dessous.',
          actions: {
            unsubscribe: 'Se désabonner',
            subscribe: 'S’abonner',
            delete: 'Supprimer',
            addPlaceholder: 'Entrer l’ID du point de comptage',
            status: {
              waitingApproval: 'En attente de l’accord du client pour Elhub',
            },
            validation: {
              onlyDigits: 'L’ID doit contenir uniquement des chiffres',
              exactLength:
                'L’ID doit comporter exactement 18 chiffres (ex. 707057500042153290)',
              startsWith: 'L’ID doit commencer par 7070575000',
              unique: 'ID doit être unique',
            },
            move: {
              selectTargetBuilding: '- Sélectionner bâtiment cible -',
              moveSelected: 'Déplacer la sélection',
              instructions:
                'Cochez les abonnements à déplacer (jusqu’à 1 min par abonnement).',
              moveSubscriptions: 'Déplacer abonnements',
            },
            feedback: {
              subscribeSuccess: 'Demande d’abonnement envoyée',
              unsubscribeSuccess: 'Désabonnement réussi',
              deleteSuccess: 'Abonnement supprimé',
              subscribeError: 'Échec de la demande',
              unsubscribeError: 'Échec du désabonnement',
              deleteError: 'Échec de la suppression',
            },
          },
        },
      },
      report: { title: 'Rapport' },
    },
    model3d: {
      title: 'Modèle 3D',
    },
    zoneEdit: {
      title: 'Paramètres de la zone',
      form: {
        zoneName: 'Nom de la zone',
        floorNumber: 'Étage',
        selectCategory: 'Choisir une catégorie',
        isHeated: 'Zone chauffée',
        displayHint: 'Apparence de la zone dans la vue 3D.',
        cardSize: 'Taille de la carte',
        zoneColor: 'Couleur de la zone',
        devices: {
          availableDevices: 'Appareils disponibles',
          zoneDevices: 'Appareils de la zone',
          noMatches: 'Aucun appareil ne correspond à la recherche',
        },
        deleteButton: 'Supprimer la zone',
        deleteZoneDescription: 'Supprime définitivement la zone.',
        deleteZoneConfirm: 'Voulez-vous vraiment supprimer cette zone ?',
        deleteError: 'Échec de la suppression de la zone',
      },
    },
    technicalRoom: {
      titles: 'Salles techniques',
      emptyState: 'Aucune salle technique trouvée.',
      technicalRoomDescription: 'Description de la salle technique',
      technicalRoomNamePlaceholder: 'Nom de la salle technique',
      technicalRoomDevices: 'Appareils dans la salle technique',
      addDevice: 'Ajouter un appareil',
      technicalRoomDevice: 'Appareil de la salle technique',
      removeDevice: 'Supprimer',
      searchPlaceholder: 'Rechercher une salle technique',
      technicalRoomOverview: 'Aperçu salle technique',
      technicalRoomValue: 'Valeur',
      technicalRoomSeen: 'Dernière vue',
      addTechnicalRoom: 'Ajouter une salle technique',
      addDeviceButton: 'Ajouter un appareil',
      removeDeviceButton: 'Supprimer',
      deviceType: 'Type d’appareil',
      editorTitle: 'Salles techniques',
      selectRoom: 'Sélectionner une salle technique',
      threeDModel: 'Modèle 3D',
      replace: 'Remplacer',
      selectModel: 'Sélectionner un modèle 3D',
      modelDefaultsGroup: 'Modèles par défaut',
      noModel: 'Aucun modèle 3D associé à cette salle.',
      bind: 'Associer',
      rebind: 'Réassocier',
      unbind: 'Dissocier',
      boundTo: 'Associé à',
      notBound: 'Non associé',
      hide: 'Masquer en 3D',
      show: 'Afficher en 3D',
      size: 'Taille',
      remove: 'Retirer de la salle',
      pickingHint: 'Cliquez sur le modèle pour associer',
      pickingCardHint:
        'Cliquez sur une partie du modèle, ou sur le fond pour placer la carte librement',
      searchDevices: 'Rechercher des appareils…',
      noDevicesAvailable: 'Aucun appareil disponible',
      noMatches: 'Aucun résultat',
      unnamedDevice: 'Appareil sans nom',
      couldNotAddDevice: 'Impossible d’ajouter l’appareil',
      noReadings24h: 'Aucune mesure ces dernières 24 heures',
      dragToReposition: 'Faire glisser pour repositionner',
      hideGraph: 'Masquer le graphique',
      showGraph: 'Afficher le graphique',
      lockedHint: 'Déverrouillez la vue pour déplacer les appareils',
      clickToEdit: 'Cliquer pour modifier',
      noDescription: 'Aucune description',
      noTitle: 'Aucun titre',
      showCardTitle: 'Titre de la carte',
      showDeviceName: 'Nom de l’appareil',
      cardVisualization: 'Visualisation de la carte',
      modelAnimation: 'Animation du modèle',
      showLine: 'Ligne de liaison',
      lineColor: 'Couleur de la ligne',
      resetColor: 'Réinitialiser la couleur',
      darkTheme: 'Thème sombre',
      showUnit: 'Unité',
      trendLine: 'Courbe de tendance',
      trendBars: 'Barres de tendance',
      showUpdated: 'Dernière mise à jour',
      visualizationRules: 'Règles de visualisation',
      ruleDataKey: 'Clé de données',
      ruleValue: 'Valeur',
      triggers: 'Déclencheurs',
      addTrigger: 'Ajouter un déclencheur',
      ruleOff: 'Désactivé',
      ruleSlow: 'Lent',
      ruleFast: 'Rapide',
      ruleNoEffect: 'Aucun effet',
      ruleNoColor: 'Aucune couleur',
      ruleReverse: 'Inverser le sens',
      particleFlow: 'Flux de particules',
      drawFlow: 'Dessiner un flux',
      flowHint: 'Cliquez sur le modèle pour ajouter des points.',
      flowFollowsHint:
        "Les particules suivent les déclencheurs de l'animation du modèle. Quand l'animation est arrêtée, les particules s'arrêtent.",
      flowColorHint:
        'Cliquez sur un point du flux dans le modèle pour changer sa couleur à partir de là.',
      flowColorFromPoint: 'Couleur à partir du point sélectionné',
      flowFollows: "Suit l'animation",
      particles: 'Particules',
      ruleDataKeyRequired:
        'Sélectionnez une clé de données pour la règle de visualisation',
      newTechnicalRoom: 'Nouvelle salle technique',
      roomNamePlaceholder: 'ex. Ventilation, Chaufferie, Pompe à chaleur',
      selectBuilding: 'Sélectionner un bâtiment',
      nameRequired: 'Le nom est requis',
      buildingRequired: 'Le bâtiment est requis',
      couldNotCreateRoom: 'Impossible de créer la salle',
      creating: 'Création en cours',
      loadError: 'Impossible de charger la salle technique',
      textPlaceholder: 'Saisir le texte…',
      noText: 'Aucun texte',
      linkToRoom: 'Aller à la salle',
      noLink: 'Aucun lien',
      linkHint:
        'En vue verrouillée, un clic sur le modèle ou la carte ouvre cette salle.',
      confirmRemoveAnnotation:
        'Voulez-vous vraiment retirer ce texte de la salle ?',
      dragToReorder: 'Glisser pour réordonner',
      drawFrame: 'Dessiner le cadre',
      redrawFrame: 'Redessiner le cadre',
      frameDrawHint: 'Cliquez sur deux coins du dessin',
      noFrame: 'Aucun cadre dessiné',
      frameDrawn: 'Cadre dessiné',
      confirmRemoveFrame: 'Voulez-vous vraiment retirer ce cadre de la salle ?',
      confirmRemoveLink: 'Voulez-vous vraiment retirer ce lien de la salle ?',
      annotationsTab: 'Liens et texte',
      noAnnotations: 'Aucun lien ni texte dans cette salle.',
      placeText: 'Placer',
      replaceText: 'Placer à nouveau',
      placed: 'Placé',
      placeTextHint: 'Cliquez sur le dessin là où le texte doit se trouver',
      placeInfoHint: 'Cliquez sur le dessin là où la bulle doit se trouver',
      confirmRemoveInfo:
        'Voulez-vous vraiment retirer cette bulle d’information de la salle ?',
      ruleAngle: 'Angle (degrés)',
      infoPanel: "Alarmes et calendrier d'exploitation",
      alarmsTab: 'Alarmes',
      calendarsTab: "Calendrier d'exploitation",
      noAlarmSystems: "Aucun système d'alarme n'est relié à cette salle.",
      noCalendars: "Aucun calendrier d'exploitation n'est relié à cette salle.",
      systemAlarm: 'Alarme système',
      openInSettings: 'Ouvrir dans les paramètres',
      confirmRemoveDevice:
        'Voulez-vous vraiment retirer cet appareil de la salle ?',
      attributes: 'Attributs',
      selectAttribute: 'Sélectionner un attribut',
      mappedGroup: 'Attributs mappés',
      payloadGroup: 'Données brutes',
      mappedNoneText: 'Aucun disponible,',
      assignHere: 'attribuer ici',
      confirmDeleteRoom: 'Voulez-vous vraiment supprimer {name} ?',
      roomDeleted: 'Salle technique supprimée',
      renameRoom: 'Renommer la salle technique',
      noTechnicalRoomsForType: 'Aucune salle technique de ce type trouvée',
      noDevices: 'Aucun appareil dans cette salle technique.',
      technicalRoomTypeLabel: 'Type de salle technique',
      technicalRoomTypes: {
        type: 'Sélectionner le type',
        hvac: 'CVC',
        technical: 'Salle technique',
        electrical: 'Électrique',
        plumbing: 'Plomberie',
        other: 'Autre',
      },
      message: {
        success: 'Salle technique créée avec succès',
        updateSuccess: 'Salle technique mise à jour avec succès',
        deleteSuccess: 'Salle technique supprimée avec succès',
        error: 'Une erreur est survenue lors du traitement de votre demande',
        deleteConfirm:
          'Êtes-vous sûr de vouloir supprimer cette salle technique ?',
      },
    },
  },
  threeD: {
    lockView: 'Verrouiller la vue',
    unlockView: 'Déverrouiller la vue',
  },

  buildings3D: {
    header: {
      buildingTab: 'Bâtiment',
      technicalTab: 'Technique',
    },
    footer: {
      home: 'Accueil',
      measure: 'Mesurer',
      stopMeasure: 'Arrêter mesure',
      explode: 'Exploser',
      screenshot: 'Capture d’écran',
      lock: 'Verrouiller',
      unlock: 'Déverrouiller',
    },
    climate: {
      buildingClimate: 'Sisäilmasto',
      levelsTitle: 'Osiot',
      startLabel: 'Alku',
      endLabel: 'Loppu',
      apply: 'Käytä',
      avgTemperature: 'Keskilämpötila',
      avgHumidity: 'Keskimääräinen ilmankosteus',
      avgCo2: 'Keskimääräinen CO₂',
      floor: 'Kerros',
      wholeBuilding: 'Bâtiment entier',
      noTrendData: 'Ei dataa',
      fetchData: 'Hae data',
      startMustBeBeforeEnd: 'Alun on oltava ennen loppua.',
      groundFloor: 'Katukerros',
      weekdaysShort: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    },
    status: {
      good: 'Hyvä',
      tooLow: 'Liian matala',
      tooHigh: 'Liian korkea',
      warning: 'Varoitus',
      poor: 'Huono',
    },
    warnings: {
      title: 'Avertissements',
      highCo2: 'CO₂ élevé',
      highTemp: 'Température élevée',
      lowTemp: 'Température basse',
    },
    alarmLog: {
      title: 'Journal des alarmes',
      last24h: 'Dernières 24 heures',
      last7d: 'Derniers 7 jours',
      last30d: 'Derniers 30 jours',
      custom: 'Personnalisé',
      zone: 'Zone',
      activeNow: 'Actives maintenant',
      today: "Aujourd'hui",
      yesterday: 'Hier',
      earlier: 'Plus tôt',
      empty: 'Aucune alarme sur cette période',
      loadError: 'Impossible de charger le journal des alarmes.',
      unknownZone: 'Zone inconnue',
    },
    deviceLayer: {
      moveDevices: 'Déplacer les modèles',
      moveHint: 'Glissez pour déplacer · ⇧ pivoter · ⌘ hauteur',
      moveThisDevice: 'Déplacer cet appareil',
      doneMoving: 'Terminer le déplacement',
      changeModel: 'Changer de modèle',
      showDataBox: 'Afficher la boîte de données',
      hideDataBox: 'Masquer la boîte de données',
      modelSize: 'Taille du modèle',
      dataSize: 'Taille des données',
      hideZones: 'Masquer les zones',
      showZones: 'Afficher les zones',
      hideModels: 'Masquer les modèles',
      showModels: 'Afficher les modèles',
      hideModel: 'Masquer le modèle',
      showModel: 'Afficher le modèle',
      suggested: 'Suggéré',
      noModelsInCategory: 'Aucun modèle dans cette catégorie pour l’instant',
      controllers: 'Contrôleurs',
      models: {
        radiatorGlb: 'Radiateur',
        panelOvenGlb: 'Panneau rayonnant',
        heatpumpGlb: 'Pompe à chaleur',
        indoorClimateGlb: 'Climat intérieur',
        icmSensorGlb: 'Capteur ICM',
        climateHubGlb: 'Hub climatique',
        ventilationOutletGlb: 'Bouche de ventilation',
        ventilationGrillGlb: 'Grille de ventilation',
      },
    },
    zoneControls: {
      leaveFloor: 'Quitter',
      drawZone: 'Double-cliquez pour terminer',
      clearZones: 'Effacer les zones',
      clickFloorToIsolate: 'Cliquez sur l’étage pour isoler',
      select: 'Sélectionner',
      rectangle: 'Rectangle',
      circle: 'Cercle',
      polygon: 'Polygone',
      zoneNameLabel: 'Nom de la zone',
      heightLabel: 'Hauteur',
      editVertexHint:
        'Glissez les points pour modifier, double-cliquez pour en ajouter',
      unnamedZone: 'Zone sans nom',
      zoneNameRequired: 'Le nom de la zone est requis',
      zonesMissingData: 'Zones sans données 3D',
      zonesMissingDataTitle: 'Zones sans données de modèle 3D :',
      floorLabel: 'Étage',
      zoneCreated: 'Zone créée',
      zoneUpdated: 'Zone mise à jour',
      zoneDeleted: 'Zone supprimée',
      failedToCreateZone: 'Échec de la création de la zone',
      failedToUpdateZone: 'Échec de la mise à jour de la zone',
      failedToDeleteZone: 'Échec de la suppression de la zone',
      confirmDeleteZoneTitle: 'Supprimer la zone ?',
      confirmDeleteZoneMessage:
        'Êtes-vous sûr de vouloir supprimer cette zone ? Cette action est irréversible.',
    },
  },

  deviceAlarms: {
    updatedSuccess: "Alarme d'appareil mise à jour avec succès",
    createdSuccess: "Alarme d'appareil créée avec succès",
    deletedSuccess: "Alarme d'appareil supprimée avec succès",

    editTitle: "Modifier l'alarme d'appareil",
    createTitle: "Créer une alarme d'appareil",
    title: `Alarmes d'appareil`,
    manageAlarmsForDevice: 'Gérer les alarmes pour {device}',
    recipients: 'Liste des destinataires',

    alarmDetails: "Détails de l'alarme",
    deviceSelection: "Sélection de l'appareil",
    alarmConditions: "Conditions d'alarme",
    condition: 'Condition',
    conditions: 'Conditions',
    noConditions: 'Aucune condition ajoutée pour le moment.',
    noConditionsSaveError: 'Au moins une condition est requise',

    name: 'Nom',
    description: 'Description',
    alarmSystem: "Système d'alarme",
    selectDevice: 'Sélectionner un appareil',
    dataKey: 'Clé de données',
    selectKey: 'Sélectionner une clé',
    level: 'Niveau',
    operator: 'Opérateur',
    value: 'Valeur',
    duration: 'Durée (min)',
    message: 'Message',
    active: 'Actif',

    greaterThan: 'Supérieur à',
    lessThan: 'Inférieur à',
    equal: 'Égal',
    notEqual: 'Différent',
    missing: 'Manquant',
    unchanged: 'Inchangé',

    addTrigger: 'Ajouter un déclencheur',
    addCondition: 'Ajouter une condition',
    triggers: 'Déclencheurs',

    standardDevices: 'Appareils standard',
    eosDevices: 'Appareils EOS',
    noDataKeys: 'Aucune clé de données disponible pour cet appareil.',

    noAlarmSystems: "Aucun système d'alarme disponible.",
    pleaseCreateFirst: "Veuillez d'abord en créer un",
    selectDeviceFirst:
      "Veuillez d'abord sélectionner un appareil pour configurer les conditions d'alarme.",
    messagePlaceholder: "Message d'alerte à afficher...",
    confirmDelete:
      "Êtes-vous sûr de vouloir supprimer cette alarme d'appareil ?",
    list: {
      new: 'Nouveau',
      search: 'Rechercher...',
      empty: "Aucune alarme d'appareil trouvée",
    },
    deleteAlarmTitle: 'Supprimer l’alarme',
    deleteAlarmDescription: 'Cette action est irréversible.',
  },

  settings: {
    areas: {
      home: 'Accueil',
      vendor: 'Général',
      devices: 'Appareils',
      eos_devices: 'Appareils EOS',
      categories: 'Catégories',
      users: 'Utilisateurs',
      themes: 'Thèmes',
      integrationOverview: 'Intégrations API',
      fileCloud: 'Cloud de fichiers',
      energyPrices: "Prix de l'énergie",
      alarms: 'Alarmes',
      alarmSystemDescription:
        'Gérez et personnalisez les systèmes d’alarme avec des notifications sur mesure et une surveillance du rythme cardiaque pour rester informé des événements critiques et garantir des réponses en temps opportun.',
      baseline: 'Ligne de référence',
      technicalRoomOverview: 'Salles techniques',
      aspaSetup: 'Configuration ASPA',
      controlStrategy: 'Stratégie de contrôle',
      operatingCalendar: 'Calendriers d’exploitation',
      setpoint: 'Points de consigne',
    },

    home: {
      title: 'Tableau de bord entreprise',
      tagline:
        'Gérez les paramètres, les utilisateurs, les appareils et les thèmes de votre entreprise en un seul endroit',
    },

    dashboardItems: {
      themes: {
        title: 'Thèmes',
        description: 'Créez et gérez les thèmes couleur de votre application',
        linkText: 'Voir les thèmes',
      },
      users: {
        title: 'Utilisateurs',
        description: 'Gérez les comptes et les autorisations des utilisateurs',
        linkText: 'Voir les utilisateurs',
      },
      eosDevices: {
        title: 'Appareils EOS',
        description: 'Surveillez et gérez les capteurs de suivi énergétique',
        linkText: 'Voir les appareils EOS',
      },
      settings: {
        title: 'Paramètres',
        description: 'Configurez les paramètres globaux de l’application',
        linkText: 'Voir les paramètres',
      },
      devices: {
        title: 'Appareils',
        description: 'Configurez et surveillez les appareils connectés',
        linkText: 'Voir les appareils',
      },
      fileCloud: {
        title: 'Cloud de fichiers',
        description:
          'Stockez, organisez et partagez des fichiers au sein de votre organisation',
        linkText: 'Voir les fichiers',
      },
      integration: {
        title: 'Intégrations API',
        description: 'Configurez et gérez les connexions et intégrations API',
        linkText: 'Voir les intégrations',
      },
      categories: {
        title: 'Catégories',
        description: 'Créez et gérez les catégories d’appareils',
        linkText: 'Voir les catégories',
      },
    },

    aspaSetup: {
      list: {
        header: 'Configuration ASPA',
        addButton: 'Ajouter une configuration ASPA',
        emptyState: 'Aucune configuration ASPA trouvée.',
        searchPlaceholder: 'Rechercher...',
      },
      edit: {
        name: 'Nom de la configuration ASPA',
        units: 'Unités',
        addUnit: 'Ajouter une unité',
        unitName: "Nom de l'unité",
        setpoints: 'Points de consigne',
        zones: 'Zones',
        removeUnit: "Supprimer l'unité",
        copyMondayToWeekdays: 'Copier lundi aux jours de semaine',
        copyMondayToAllDays: 'Copier lundi à tous les jours',
      },
      feedback: {
        deleteSuccess: 'Configuration ASPA supprimée avec succès',
        deleteError:
          'Une erreur est survenue lors de la suppression de la configuration ASPA',
        updateSuccess: 'Configuration ASPA mise à jour avec succès',
        updateError:
          'Une erreur est survenue lors de la mise à jour de la configuration ASPA',
        createSuccess: 'Configuration ASPA créée avec succès',
        createError:
          'Une erreur est survenue lors de la création de la configuration ASPA',
        saveError:
          'Une erreur est survenue lors de la sauvegarde de la configuration ASPA',
      },
    },

    energyPrices: {
      list: {
        add: 'Ajouter un tarif énergétique',
        header: 'Paramètres des tarifs énergétiques',
        emptyState: 'Aucun paramètre de tarif énergétique trouvé.',
        searchPlaceholder: 'Rechercher des paramètres de tarif énergétique...',
      },

      name: 'Nom',
      notes: 'Notes',
      building: 'Bâtiment',
      selectBuilding: 'Sélectionner un bâtiment',
      validFrom: 'Valide à partir du',
      validTo: 'Valide jusqu’au',
      ongoing: 'En cours',
      notSpecified: 'Non spécifié',

      electricityDetails: 'Détails électricité',
      priceModel: 'Modèle tarifaire',
      fixed: 'Prix fixe',
      spotMarkup: 'Spot + majoration',
      fixedPricePerKWh: 'Prix fixe par kWh',
      spotMarkupPerKWh: 'Majoration par kWh',

      supplierMonthlyFee: 'Frais mensuels du fournisseur',
      co2Emissions: 'Émissions de CO₂ (gCO₂/kWh)',

      gridTariffs: 'Frais de réseau',
      gridTariff: 'Frais de réseau',
      fixedMonthly: 'Frais mensuels fixes',
      energyPerKWh: 'Énergie par kWh',
      demandPerKWMonthly: 'Frais de puissance par kW et par mois',
      consumptionTaxPerKWh: 'Taxe de consommation par kWh',

      energySources: 'Sources d’énergie',
      addEnergySources: 'Ajouter des sources d’énergie',
      energySource: 'Informations sur la source d’énergie',
      sourceName: 'Nom de la source',
      electricity: 'Électricité livrée',
      electricityPrice: 'Prix de l’électricité',
      electricityProduced: 'Électricité produite',
      electricityExported: 'Électricité exportée',

      districtHeating: 'Chauffage urbain',
      districtHeatingSource: 'Source énergétique du chauffage urbain',
      districtHeatingPrice: 'Prix du chauffage urbain',
      districtHeatingEnergyPrice: 'Prix de l’énergie (kr/kWh)',
      districtHeatingDemandPerKWMonthly:
        'Puissance maximale mesurée (kr/kW/mois)',

      fuelSources: 'Sources de combustible',
      fuelSource: 'Informations sur la source de combustible',
      fuelType: 'Source d’énergie',

      propane: 'Propane',
      fuelOilDiesel: 'Fioul / Diesel',
      lng: 'Gaz naturel (GNL)',
      kerosene: 'Kérosène',
      pelletsBricks: 'Pellets / Briquettes',
      biodiesel: 'Biodiesel',
      biogas: 'Biogaz',
      other: 'Autre',

      consumptionUnit: 'Unité de consommation',
      kg: 'kg',
      liter: 'litre',
      unitPrice: 'Prix unitaire',
      consumption: 'Consommation',
      conversionFactorToKWh: 'Facteur de conversion en kWh',

      periodLabel: 'Période',
      periodLabelPlural: 'Périodes',
      periodName: 'Nom de la période',
      addPeriod: 'Ajouter une période',
      removePeriod: 'Supprimer la période',
      removePeriodConfirmation:
        'Êtes-vous sûr de vouloir supprimer cette période ?',
      noPeriodsDefined: 'Aucune période.',
      overlappingPeriodsError:
        'Les périodes "{p1}" et "{p2}" se chevauchent.\n\n' +
        'Il n’est pas possible d’avoir deux périodes actives en même temps (mêmes mois et horaires qui se chevauchent). ' +
        'Ajustez les mois ou les heures actives avant d’enregistrer.',
      confirmRemovePeriod: 'Êtes-vous sûr de vouloir supprimer la période ?',
      mixedMonthsError:
        'Il est impossible de mélanger des mois spécifiques avec "tous les mois" (mois vides) entre différentes périodes.\n\n' +
        'Ces périodes doivent sélectionner des mois : {periods}\n\n' +
        'Astuce : sélectionnez des mois pour toutes les périodes ou laissez les mois vides pour toutes.',

      generalInformation: 'Informations générales',
      activeMonths: 'Mois actifs (tous si vide)',
      activeBetween: 'Heures actives (toute la journée si vide)',
      chosenMonths: 'Mois sélectionnés',
      activeHours: 'Horaires actifs',
      allYear: 'Toute l’année',
      allDay: 'Toute la journée',

      co2Source: 'Type d’énergie du chauffage urbain',
      co2Array: [
        'Électricité',
        'Déchets',
        'Fioul léger',
        'Fioul lourd',
        'Gaz de pétrole liquéfié (GPL)',
        'Gaz naturel (GNL)',
        'Biomasse bois primaire',
        'Biomasse bois secondaire',
        'Plaquettes RT',
        'Pellets, briquettes et poudre',
        'Bio-huile',
        'Pompe à chaleur',
      ],

      fixedFees: 'Frais fixes',
      substationFee: 'Frais de sous-station (par mois)',
      reactiveEffect: 'Frais pour l’énergie réactive',
      connectedDevices: 'Appareils connectés',
      noConnectedDevices: 'Aucun appareil connecté',
      deletedDevice: 'Supprimé',
      removeSource: 'Supprimer la source',
      noLinkedDevices: 'Aucun appareil associé',
      linked: 'Appareils associés',
      unlinkDeviceMessage: 'Êtes-vous sûr de vouloir supprimer cet appareil ?',
      addAdditionalTimer: 'Ajouter un intervalle de temps supplémentaire',
      startTime: 'Heure de début ',
      endTime: 'Heure de fin ',
      timeRangeInvalid:
        'L’heure de fin doit être postérieure à l’heure de début',
      timeRangesOverlap: 'Les plages horaires ne peuvent pas se chevaucher',
      timeRangeEqual:
        'L’heure de début et l’heure de fin ne peuvent pas être identiques',

      linkSourceTitle: 'Associer la source à un appareil EOS',
      linkSource: 'Associer la source à des appareils EOS',
      linkSourceDescription:
        'Sélectionnez les appareils EOS associés à cette source d’énergie.',

      removeElectricitySourceConfirmation:
        'Êtes-vous sûr de vouloir supprimer la source électrique ',
      removeDistrictHeatingSourceConfirmation:
        'Êtes-vous sûr de vouloir supprimer la source de chauffage urbain ',
      removeFuelSourceConfirmation:
        'Êtes-vous sûr de vouloir supprimer la source de combustible ',
    },

    setpoint: {
      title: 'Points de consigne',
      backToList: 'Tous les points de consigne',
      description:
        'Limites de température, d’humidité et de CO₂ par bâtiment et par zone.',
      searchPlaceholder: 'Rechercher des points de consigne …',
      emptyState: 'Aucun point de consigne pour le moment.',
      addButton: 'Nouveau point de consigne',
      loadError: 'Impossible de charger les points de consigne.',
      zonesLoadError: 'Impossible de charger les zones.',
      saveError: 'Impossible d’enregistrer le point de consigne.',
      deleteError: 'Impossible de supprimer le point de consigne.',
      requiredError: 'Ces champs sont obligatoires :',
      deleteConfirmTitle: 'Supprimer le point de consigne',
      deleteConfirmMessage:
        'Voulez-vous vraiment supprimer ce point de consigne ? Cette action est irréversible.',
      editTitle: 'Modifier le point de consigne',
      newTitle: 'Nouveau point de consigne',
      editDescription: 'Les limites s’appliquent aux zones sélectionnées.',
      saveButton: 'Enregistrer le point de consigne',
      openSetpoint: 'Ouvrir le point de consigne',
      buildingSection: 'Bâtiment',
      building: 'Bâtiment',
      name: 'Nom',
      namePlaceholder: 'Ex. Bureau standard',
      zonesSection: 'Zones',
      selectAll: 'Tout sélectionner',
      clearAll: 'Tout effacer',
      noZones: 'Choisissez un bâtiment pour voir ses zones.',
      allZonesTaken:
        'Toutes les zones de ce bâtiment ont déjà un point de consigne.',
      zonesTakenError:
        'Une ou plusieurs zones appartiennent déjà à un autre point de consigne.',
      noZonesSelected: 'Aucune zone sélectionnée',
      floor: 'Étage',
      noFloor: '—',
      limitsSection: 'Limites',
      columns: {
        name: 'Nom',
        building: 'Bâtiment',
        zones: 'Zones',
        inOperation: 'En service',
        outsideOperation: 'Hors service',
        interval: 'Intervalle de vérification',
      },
    },
    operatingCalendar: {
      backToList: 'Tous les calendriers',
      title: 'Calendriers d’exploitation',
      description:
        'Heures d’exploitation normales par bâtiment et zone, avec l’exploitation extraordinaire par-dessus.',
      searchPlaceholder: 'Rechercher des calendriers …',
      emptyState: 'Aucun calendrier d’exploitation.',
      addButton: 'Nouveau calendrier',
      running: 'En cours, sans date de fin',
      openCalendar: 'Ouvrir le calendrier',
      zonesLoadError: 'Impossible de charger les zones.',
      loadError: 'Impossible de charger les calendriers.',
      saveError: 'Impossible d’enregistrer le calendrier.',
      deleteError: 'Impossible de supprimer le calendrier.',
      requiredError: 'Ces champs sont obligatoires :',
      deleteConfirmTitle: 'Supprimer le calendrier',
      deleteConfirmMessage:
        'Voulez-vous vraiment supprimer ce calendrier ? Cette action est irréversible.',
      editTitle: 'Définir l’exploitation normale',
      editDescription:
        'Heures hebdomadaires fixes pour les zones sélectionnées.',
      saveButton: 'Enregistrer l’exploitation normale',
      buildingSection: 'Bâtiment',
      building: 'Bâtiment',
      zonesSection: 'Zones',
      selectAll: 'Tout sélectionner',
      clearAll: 'Tout effacer',
      noZonesSelected: 'Aucune zone sélectionnée',
      zonesTakenError:
        'Une ou plusieurs zones appartiennent déjà à un autre calendrier.',
      allZonesTaken:
        'Toutes les zones de ce bâtiment appartiennent déjà à un calendrier.',
      noZones: 'Choisissez un bâtiment pour voir ses zones.',
      floor: 'Étage',
      noFloor: 'Sans étage',
      validitySection: 'Nom et validité',
      name: 'Nom',
      validFrom: 'Valide à partir du',
      validTo: 'Valide jusqu’au',
      weekPlanSection: 'Plan hebdomadaire',
      copyMonday: 'Copier lundi sur tous les jours ouvrés',
      noOperation: 'Aucune exploitation',
      weeklyTotal: 'Total par semaine',
      from: 'De',
      to: 'À',
      calendarTitle: 'Calendrier d’exploitation',
      week: 'Semaine',
      previousWeek: 'Semaine précédente',
      nextWeek: 'Semaine suivante',
      today: 'Aujourd’hui',
      editNormal: 'Exploitation normale',
      addOverride: 'Ajouter une exploitation extraordinaire',
      thisWeek: 'Cette semaine',
      operatingHours: 'Heures d’exploitation',
      extraordinaryDays: 'Jours extraordinaires',
      upcomingOverrides: 'Exploitation extraordinaire à venir',
      noOverrides: 'Rien de prévu.',
      fixedOperation: 'Exploitation fixe',
      publicHoliday: 'Jour férié',
      extraordinary: 'Exploitation extraordinaire',
      closed: 'Fermé',
      opensAt: 'Ouvre',
      closesAt: 'Ferme',
      inOperation: 'En service',
      outOfOperation: 'Hors service',
      allDay: 'Toute la journée',
      reason: 'Motif',
      overrideSaveError:
        'Impossible d’enregistrer l’exploitation extraordinaire.',
      overrideDeleteError: 'Suppression impossible.',
      columns: {
        name: 'Nom',
        building: 'Bâtiment',
        zones: 'Zones',
        validity: 'Validité',
        hoursPerWeek: 'Heures/sem.',
      },
      weekdays: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Jeu',
        fri: 'Ven',
        sat: 'Sam',
        sun: 'Dim',
      },
    },
    controlStrategy: {
      list: {
        header: 'Stratégies de contrôle',
        addButton: 'Ajouter une stratégie',
        emptyState: 'Aucune stratégie de contrôle trouvée.',
        searchPlaceholder: 'Rechercher par bâtiment...',
      },
      feedback: {
        saveSuccess: 'Stratégie de contrôle enregistrée',
        saveError: "Une erreur s'est produite lors de l'enregistrement",
        buildingRequired: 'Le bâtiment est obligatoire',
        bothHoursRequired:
          "L'heure de début et de fin doivent être renseignées",
        startBeforeEnd:
          "L'heure de début doit être antérieure à l'heure de fin",
        deleteSuccess: 'Stratégie de contrôle supprimée',
        deleteError: 'Une erreur est survenue lors de la suppression',
        confirmDeleteTitle: 'Supprimer la stratégie de contrôle',
        confirmDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer cette stratégie ? Cette action est irréversible.',
      },
      schedule: 'Heures de service',
      timezone: 'Fuseau horaire',
      startHour: 'Heures de service début',
      endHour: 'Heures de service fin',
      actions: 'Actions',
      coolingLevel: 'Niveau de refroidissement',
      heatingLevel: 'Niveau de chauffage',
      businessHoursControl: 'Contrôle pendant les heures ouvrables',
      afterHoursControl: 'Contrôle hors heures ouvrables',
      controlOutsideBusinessHours: 'Contrôler hors heures ouvrables',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp max (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ max (ppm)',
      actionLabels: {
        cool: 'Refroidir',
        heat: 'Chauffer',
        preCool: 'Pré-refroidir',
        preHeat: 'Préchauffer',
        ventilate: 'Ventiler',
        dehumidify: 'Déshumidifier',
      },
      closed: 'Fermé',
      afterHoursActions: 'Actions hors horaires',
    },

    baseline: {
      updated: 'Mis à jour',
      title: 'Référence',
      searchPlaceholder: 'Rechercher une référence...',
      addButtonLabel: 'Créer une nouvelle référence',
      confirmDeleteTitle: 'Supprimer la référence',
      confirmDeleteMessage:
        'Êtes-vous sûr de vouloir supprimer cette référence ?',
      noBaselines: 'Aucune référence trouvée. Créez une nouvelle référence.',
      createNewBaselineConfirm:
        'Créer une nouvelle référence ? Cela remplacera l’existante.',
      editBaseline: 'Modifier la référence pour',
      calculateBaseline: 'Calculer la référence',
      baselineChart: 'Graphique de référence',
      monthsCovered: 'Mois couverts',
      excludeMonths: 'Exclure des mois',
      pendingChanges:
        'Modifications non enregistrées. Cliquez sur Enregistrer pour mettre à jour la référence.',
      clickMonthsToExclude: `Cliquez sur les mois pour les exclure de la ligne de base. Les mois en orange présentent un écart de 20 % ou plus par rapport à la ligne de base.`,
      year: 'Année',
      month: 'Mois',
      energyType: 'Type d’énergie',
      monthlySummary: 'Résumé mensuel',
      weeklySummary: 'Résumé hebdomadaire',
      week: 'Semaine',
      summary: 'Résumé',
      excluded: 'Exclu de la référence',
      energyTypes: {
        electricity: 'Électricité',
        districtHeating: 'Chauffage urbain',
        fuel: 'Combustible',
      },
      overBaseline: 'Au-dessus de la référence',
      underBaseline: 'En dessous de la référence',
      included: 'Inclus dans la référence',
      activeLabel: 'Actif',
      inactiveLabel: 'Inactif',
      createdAt: 'Créé',
      lockTooltip: {
        locked: 'Verrouillé — cliquez pour autoriser les modifications',
        unlocked: 'Verrouiller pour bloquer les modifications',
      },
      description: 'Créer et configurer des références',
      backButtonLabel: 'Retour aux références',
    },

    topics: {
      addButton: '+ Ajouter un sujet',
      eosName: 'Nom EOS',
      sensorTag: 'Tag capteur',
      sensorTagRequired: 'Le tag capteur est requis',
      sensorTagTooShort: 'Le tag capteur doit comporter au moins 3 caractères',
      assignedTo: 'Utilisé par',
      aggregator: {
        title: 'Agrégateur',
        sum: 'Somme',
        average: 'Moyenne',
        max: 'Max',
        min: 'Min',
        cumulative: 'Cumulatif',
        differential: 'Différentiel',
        last: 'Dernier',
      },
      scale: 'Échelle',
      decimals: 'Décimales',
      units: 'Unités',
      removeButton: 'Supprimer',
      deleteTopic: 'Supprimer le sujet',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce sujet ?',
    },

    devices: {
      installNetmoreButton: 'Installer un équipement Netmore',
      gatewayInstaller: 'Installateur de passerelle Netmore',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Installer un appareil ChirpStack',
      serialNumber: 'Numéro de série',
      bulkSerialsLabel:
        'Numéros de série (séparés par une virgule ou un retour à la ligne)',
      ui: {
        singleModeTitle: 'Appareil unique',
        bulkModeTitle: 'Installation en masse',
        bulkNameHintLine1:
          'Nom vide -> les numéros de série sont utilisés comme noms',
        bulkNameHintLine2:
          'Nom défini -> tous les appareils utilisent le même nom',
      },
      visualToggle: {
        visualToggleDevice: 'Appareil Visual Toggle',
        visualToggleBuilding: 'Bâtiment',
        visualToggleDelimiter: 'élimiteur',
        visualToggleDataKey: 'Clé de données',
        visualToggleProperty: 'Propriété',
        visualTogglePropertyId: 'ID de propriété',
        visualToggleValue: 'Valeur',
        visualToggleColor: 'Couleur',
        visualToggleTriggers: 'Déclencheurs',
        visualToggleAddTrigger: 'Ajouter un déclencheur',
        visualToggleRemove: 'Supprimer le déclencheur',
        visualToggleSelectBuilding: 'Sélectionner un bâtiment',
        visualToggleSelectValue: 'Sélectionner une valeur',
        visualToggleDev: 'Appareil',
        visualToggleOverview: 'Aperçu des appareils Visual Toggle',
        visualToggleAdd: 'Ajouter un appareil Visual Toggle',
        visualToggleGlobalModels: 'Modèles 3D globaux',
        visualToggleDelete: 'Supprimer un appareil Visual Toggle',
        visualToggleNoDevices: 'Aucun appareil Visual Toggle trouvé.',
        visualToggleSearchPlaceholder:
          'Rechercher des appareils Visual Toggle...',
        visualToggleName: 'Nom',
        visualToggleTechnicalRoom: 'Local technique',
        visualToggleSelectRoom: 'Sélectionner un local technique',
        visualToggleBuildingRequired: 'Le bâtiment est requis',
        visualToggleTechnicalRoomRequired: 'Le local technique est requis',
        visualToggleDeviceRequired: 'L’appareil est requis',
        visualtoggleAxes: {
          xAxis: 'Rotation X',
          yAxis: 'Rotation Y',
          zAxis: 'Rotation Z',
          off: 'Éteint',
          half: 'Moitié',
          full: 'Plein',
          none: 'Aucun',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Êtes-vous sûr de vouloir supprimer cet appareil Visual Toggle ?',
          visualToggleDeleteSuccess:
            'Appareil Visual Toggle supprimé avec succès',
          visualToggleDeleteError:
            'Une erreur est survenue lors de la tentative de suppression de l’appareil Visual Toggle',
          visualToggleDataKey: 'Clé de données manquante',
          visualToggleTrigger: 'Déclencheur manquant',
          visualToggleProperty: 'La propriété est requise.',
          visualToggleValue: 'La valeur est requise.',
          visualToggleUpdated: 'Appareil Visual Toggle mis à jour avec succès',
          visualToggleCreated: 'Appareil Visual Toggle créé avec succès',
          visualToggleSaveError:
            'Une erreur est survenue lors de la tentative d’enregistrement de l’appareil Visual Toggle',
        },
      },
      deviceControls: {
        title: 'Contrôles de l’appareil',
        send: 'Envoyer',
        updateSuccessMessage: 'Consigne mise à jour avec succès',
        updateSuccessTitle: 'Succès',
        updateErrorTitle: 'Erreur',
        updateErrorMessage: 'Échec de la mise à jour de la consigne',
        hideAdvanced: 'Masquer les options avancées',
        showAdvanced: 'Afficher les options avancées ({count} appareils)',
        current: 'Valeur',
        range: 'De',
        duration: 'Durée (heures)',
        durationHelp:
          'Le point de consigne revient au programme après ce délai',
        comment: 'Commentaire',
        commentPlaceholder: 'Pourquoi cette dérogation ?',
        notLogged:
          'Point de consigne mis à jour, mais la dérogation n’a pas pu être enregistrée',
      },
      list: {
        header: 'Gestion des appareils',
        addButton: 'Ajouter un appareil',
        emptyState: 'Aucun appareil trouvé.',
        searchPlaceholder: 'Rechercher des appareils…',
        backButton: 'Retour aux appareils',
      },
      validation: {
        nameRequired: 'Le nom de l’appareil est requis',
        sensorTagMissing:
          'Le tag capteur est manquant pour le sujet {{index}}.',
        sensorTagTooShort:
          'Le tag capteur pour le sujet {{index}} doit comporter au moins 3 caractères.',
      },
      feedback: {
        updateSuccess: 'Appareil mis à jour avec succès',
        updateError: 'Erreur lors de la mise à jour de l’appareil',
        createSuccess: 'Appareil créé avec succès',
        installSuccess: 'Appareil installé avec succès',
        createError: 'Erreur lors de la création de l’appareil',
        duplicateDevice: 'Un appareil avec ce numéro de série existe déjà.',
        saveError: 'Erreur lors de l’enregistrement de l’appareil',
        missingAttributes:
          'Nous avons besoin que tous les champs requis soient remplis',
        validationError: 'Erreur de validation des données de l’appareil',
        serviceUnavailable:
          'Le service est temporairement indisponible. Veuillez réessayer plus tard.',
        bulkInstallSummary:
          'Installés : {installed}. Doublons : {duplicates}. Échecs : {failed}.',
      },
    },

    eosDevices: {
      energyCategories: {
        electricityGrid: 'Électricité (réseau)',
        electricityGridExport: 'Électricité exportée (réseau)',
        districtHeating: 'Chauffage urbain',
        districtCooling: 'Froid urbain',
        fossilFuels: 'Combustibles fossiles',
        biofuels: 'Biocombustibles',
        solarPV: 'Solaire photovoltaïque',
        solarThermal: 'Solaire thermique',
        otherRenewables: 'Autres énergies renouvelables (éolien, géothermie)',
        wasteHeat: 'Chaleur fatale',
      },
      list: {
        header: 'Appareils EOS',
      },
      validation: {
        sensorTagMissing:
          'Le tag capteur est manquant pour le sujet {{index}}.',
        sensorTagTooShort:
          'Le tag capteur pour le sujet {{index}} doit comporter au moins 3 caractères.',
      },
      feedback: {
        updateSuccess: 'Appareil mis à jour avec succès',
        updateError: 'Erreur lors de la mise à jour de l’appareil',
        createSuccess: 'Appareil créé avec succès',
        createError: 'Erreur lors de la création de l’appareil',
        saveError: 'Erreur lors de l’enregistrement de l’appareil',
      },
    },

    editDevice: {
      title: 'Modifier l’appareil',
      newTitle: 'Nouvel appareil',
      deviceName: 'Nom de l’appareil',
      deviceDescription: 'Description de l’appareil',
      deviceProfile: 'Profil de l’appareil',
      selectDeviceProfile: '- Sélectionner un profil d’appareil',
      setpointRange: 'Plage de Setpoint',
      setpointRangeInfo:
        'Définissez les valeurs de setpoint haute et basse pour le tag capteur, ainsi que le pas entre les setpoints.',
      minSetpoint: 'Plus bas Setpoint',
      maxSetpoint: 'Haut Setpoint',
      stepSize: 'Pas',
      controlMode: {
        label: 'Mode de contrôle',
        info: 'Détermine comment l’appareil est régulé lorsque le contrôle est déclenché.\nPas : Ajuste progressivement le setpoint vers le haut/bas du pas défini à chaque exécution, dans les limites min/max.\nBinaire : Passe directement au max (plus de chauffage/ventilation) ou au min (moins). Contrôle tout ou rien.\nPlanning : Suit uniquement les heures d’ouverture — max pendant, min en dehors. Ignore les actions ASPA.\nSetpoint : Écrit directement le setpoint souhaité, limité au min/max. Ne met à jour qu’en cas d’écart supérieur à ±0,1.',
        step: 'Pas',
        binary: 'Binaire',
        schedule: 'Planning',
        setpoint: 'Setpoint',
      },
      operatingHoursOnly: 'Contrôlé uniquement pendant les heures d’ouverture',
      dynamicSetpoints: {
        label: 'Setpoints dynamiques',
        info: 'Les setpoints dynamiques permettent à l’appareil de remplacer sa plage de setpoint en fonction d’autres valeurs de capteur. Lorsque la valeur du capteur du tag capteur remplit la condition (opérateur + seuil), le setpoint bas, le setpoint haut et le pas de cette entrée sont utilisés à la place de la plage de setpoint normale de l’appareil.\nTag capteur : le tag capteur surveillé (p. ex. commande de la batterie froide).\nOpérateur/seuil : la condition à remplir pour que le remplacement soit actif.\nSetpoint bas/haut et pas : la plage de setpoint appliquée tant que la condition est remplie.',
        add: 'Ajouter un setpoint dynamique',
        deleteTitle: 'Supprimer le setpoint dynamique',
        confirmDelete: 'Voulez-vous vraiment supprimer ce setpoint dynamique ?',
        operator: 'Opérateur',
        threshold: 'Seuil',
        validationError:
          'Tous les champs doivent être remplis pour ajouter un setpoint dynamique.',
        fieldRequired: 'Requis',
      },
      controllerSettings: 'Paramètres du contrôleur',
      status: {
        active: 'Actif',
        displayInZone: 'Afficher dans la zone',
      },
      display: 'Affichage',
      icon: 'Icône',
      deviceType: {
        label: 'Type d’appareil',
        selectDefault: '- Sélectionner le type d’appareil',
        sensor: 'Capteur',
        controller: 'Contrôleur',
      },
      dataReceiver: {
        label: 'Récepteur de données',
        selectDefault: '- Sélectionner le récepteur',
        info: 'Indiquez quel récepteur doit recevoir les valeurs de contrôle pour cet appareil.',
      },
      deviceCategory: {
        label: 'Catégorie d’appareil',
        selectDefault: 'Sélectionner une catégorie',
      },
      valueMap: 'Mapper les valeurs de l’appareil en texte (optionnel)',
      setValueMapping: 'Définir le mappage des valeurs',
      mappedAttribute: {
        label: 'Attribut mappé',
        attribute: 'Attribut',
        numberValue: 'Nombre',
        textValue: 'Texte',
        duplicateValueMapping:
          'Cette valeur est déjà attribuée à une autre propriété.',
        cancelEditValueMapping: 'Annuler',
        removeValueMapping: 'Supprimer',
        editValueMapping: 'Modifier',
        deleteTitle: 'Supprimer le mappage de valeur',
        confirmDeleteValueMapping:
          'Voulez-vous vraiment supprimer ce mappage de valeur ?',
        confirmDeleteMappedAttributeTitle: 'Supprimer l’attribut mappé',
        confirmDeleteMappedAttribute:
          'Voulez-vous vraiment supprimer cet attribut mappé ?',
      },
      topics: 'Sujets',
      inspectDevice: 'Inspecter l’appareil',
      deleteButton: {
        deleting: 'Suppression…',
        label: 'Supprimer l’appareil',
      },
      confirmDelete: 'Voulez-vous vraiment supprimer cet appareil ?',
    },

    editEosDevice: {
      title: 'Modifier l’appareil EOS',
      newTitle: 'Nouvel appareil EOS',
      deviceName: 'Nom de l’appareil',
      topics: 'Sujets',
      deviceDescription: 'Description de l’appareil',
      active: 'Actif',
      producingPower: 'Puissance produite',
      includeInBaseline: 'Inclure dans la ligne de base',
      deviceSettings: "Paramètres de l'appareil",
      energyCategory: { label: "Catégorie d'énergie" },
      provider: {
        label: 'Fournisseur',
        required: 'Un fournisseur est requis pour le chauffage urbain',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Bâtiment',
      allBuildings: 'Tous les bâtiments',
      sensorTypes: {
        HEAT: 'Chaleur',
        LIGHT: 'Lumière',
        HVAC: 'CVC',
        PRODUCTION: 'Production',
        OFFICE: 'Bureau',
        OTHER: 'Autre',
      },
      icon: 'Icône',
      deviceType: {
        label: 'Type d’appareil',
        selectDefault: '- Sélectionner le type d’appareil',
        eosSensor: 'Capteur EOS',
        eosSource: 'Source EOS',
      },
      sensorConfiguration: 'Configuration du capteur',
      deviceCategory: {
        label: 'Catégorie d’appareil',
        selectDefault: 'Sélectionner une catégorie',
      },
      sources: 'Sources',
      inspectDevice: 'Inspecter l’appareil',
      deleteButton: {
        deleting: 'Suppression…',
        label: 'Supprimer l’appareil EOS',
      },
      confirmDelete: 'Voulez-vous vraiment supprimer cet appareil ?',
    },

    categories: {
      list: {
        header: 'Catégories',
        addButton: 'Ajouter une catégorie',
        emptyState: 'Aucune catégorie trouvée.',
        searchPlaceholder: 'Rechercher des catégories…',
        backButton: 'Retour aux catégories',
      },
      feedback: {
        updateSuccess: 'Catégorie mise à jour avec succès',
        updateError: 'Erreur lors de la mise à jour de la catégorie',
        createSuccess: 'Catégorie créée avec succès',
        createError: 'Erreur lors de la création de la catégorie',
        saveError: 'Erreur lors de l’enregistrement de la catégorie',
      },
    },

    editCategory: {
      parentCategory: 'Catégorie parente',
      legend: 'Langue',
      categoryName: 'Nom de la catégorie :',
      languageType: 'Type de langue :',
      selectLanguage: 'Sélectionner la langue',
      categoryDescription: 'Description de la catégorie :',
      deleteCategory: 'Supprimer la catégorie',
      deleteConfirm: 'Voulez-vous vraiment supprimer cette catégorie ?',
      categoryType: 'Type de catégorie',
      validation: {
        categoryRequired: 'Au moins un type de catégorie est requis',
        languageRequired: 'La langue est requise',
      },
      languageOptions: {
        en: 'Anglais',
        no: 'Norvégien',
        se: 'Suédois',
        de: 'Allemand',
        fr: 'Français',
        es: 'Espagnol',
      },
      categoryTypes: {
        device: 'Appareil',
        zone: 'Zone',
        service: 'Service',
        resource: 'Ressource',
        activity: 'Activité',
      },
    },

    userManagement: {
      auditLogs: {
        viewed: 'Consulté',
        doneBy: 'Effectué par',
        noAccess:
          "Vous devez avoir le niveau 4 (administrateur système) ou supérieur pour voir les journaux d'audit.",
      },
      auditChanges: {
        readQuery: 'Ce qui a été consulté',
        title: 'Ce qui a changé',
        field: 'Champ',
        before: 'Avant',
        after: 'Après',
        created: 'Créé',
        updated: 'Mis à jour',
        deleted: 'Supprimé',
        empty:
          "Aucune modification de la base de données n'a été enregistrée pour cette requête.",
        more: "Plus d'enregistrements ont été modifiés que ceux affichés ici.",
        hidden: 'Masqué',
        largeValue: 'Valeur volumineuse',
        items: 'éléments',
        sentData: 'Données envoyées',
      },
      list: {
        header: 'Gestion des utilisateurs',
        addButton: 'Ajouter un utilisateur',
        emptyState: 'Aucun utilisateur trouvé.',
        searchPlaceholder: 'Rechercher des utilisateurs…',
        backButton: 'Retour aux utilisateurs',
      },
      feedback: {
        fetchError: 'Erreur lors du chargement des utilisateurs',
        updateSuccess: 'Utilisateur mis à jour avec succès',
        updateError: 'Erreur lors de la mise à jour de l’utilisateur',
        createSuccess: 'Utilisateur créé avec succès',
        createError: 'Erreur lors de la création de l’utilisateur',
        saveError: 'Erreur lors de l’enregistrement de l’utilisateur',
      },
    },

    editUser: {
      firstName: 'Prénom',
      lastName: 'Nom',
      userInformation: 'Informations utilisateur',
      mobileNumber: 'Numéro de mobile',
      email: 'E-mail',
      password: 'Mot de passe',
      enovaOrganization: 'Organisation',
      enovaOrganizationNumber: 'N° d’organisation',
      enovaPersonalGuid: 'GUID Enova',
      azureAccount: 'ID de compte Azure',
      role: 'Rôle',
      active: 'Actif',
      acceptEmails: 'Accepter les e-mails',
      receiveEmails: 'L’utilisateur reçoit les e-mails système',
      canLogin: 'L’utilisateur peut se connecter au système',
      hideFeedback: 'Masquer les retours',
      hidePopups: 'Masquer les pop-ups de retour',
      changePassword: 'Changer le mot de passe',
      successUpdatePassword: 'Mot de passe mis à jour',
      errorUpdatePassword: 'Échec de la mise à jour du mot de passe',
      passwordFeedback: 'Le mot de passe doit comporter au moins 8 caractères',
      addNew: 'Ajouter un nouvel utilisateur',
      calendarSetup: 'Configuration du calendrier',
      calendarStartOfDay: 'Début de journée (pour la vue calendrier)',
      calendarEndOfDay: 'Fin de journée',
      tenantAccess: {
        header: 'Accès au locataire',
        label: 'Locataire',
        addAccess: 'Ajouter un accès',
        selectTenant: '- Sélectionner le locataire -',
        assignedTenants: 'Locataires attribués',
        fetchFailed: 'Échec du chargement des locataires',
        feedback: {
          pleaseSelect: 'Veuillez sélectionner un locataire',
          alreadyAdded: 'Locataire déjà ajouté',
        },
      },
      deleteUser: {
        label: 'Supprimer l’utilisateur',
        deleting: 'Suppression…',
      },
      confirmDelete: 'Voulez-vous vraiment supprimer cet utilisateur ?',
      activityLog: "Journal d'activité",
    },

    integrationOverview: {
      edit: {
        details: {
          legend: 'Détails',
          nameLabel: 'Nom',
          activeLabel: 'Actif',
        },
        access: {
          legend: 'Accès',
          accessLevelLabel: "Niveau d'accès",
          dateFromLabel: 'Date de début',
          dateToLabel: 'Date de fin',
          accessLevelOptions: {
            noAccess: 'Aucun accès',
            readOnly: 'Lecture seule',
            readAndWrite: 'Lecture et écriture',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Clés',
          revealButton: 'Afficher',
          publicKeyLabel: 'Clé publique',
          secretKeyLabel: 'Clé secrète',
        },
      },
      feedback: {
        updateSuccess: 'Intégration mise à jour',
        createSuccess: 'Intégration créée',
        saveError: 'Échec de l’enregistrement',
        fetchSecretsError: 'Échec de la récupération des clés',
        fetchIntegrationsError: 'Échec de la récupération des intégrations',
      },
    },

    themeSettings: {
      header: {
        title: 'Thèmes',
        subtitle: 'Créez et gérez les thèmes visuels de votre entreprise',
      },
      feedback: {
        activatedSuccess: 'Thème {themeName} activé',
        deletedSuccess: 'Thème supprimé',
        updatedSuccess: 'Thème mis à jour',
        createdSuccess: 'Thème créé',
      },
      card: {
        customize: 'Personnaliser',
        fallbackDescription: 'Un thème {name}',
        confirmDelete: 'Voulez-vous vraiment supprimer le thème « {name} » ?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Orange coucher de soleil',
          description: 'Tons orange chauds et corail avec des accents sablés',
        },
        oceanBlue: {
          name: 'Bleu océan',
          description: "Tons bleus rafraîchissants inspirés par l'océan",
        },
        crimsonRed: {
          name: 'Rouge cramoisi',
          description:
            'Cramoisi audacieux porté par des teintes rouges énergiques',
        },
        forestGreen: {
          name: 'Vert forêt',
          description: 'Verts forestiers apaisants avec des accents naturels',
        },
        blackAndWhite: {
          name: 'Noir et blanc',
          description:
            'Contraste noir et blanc intemporel pour un look moderne',
        },
        classicGray: {
          name: 'Gris classique',
          description: 'Thème gris professionnel avec des contrastes subtils',
        },
        modernWhite: {
          name: 'Blanc moderne',
          description:
            'Blanc intemporel pour une esthétique épurée et minimaliste',
        },
      },
      dialog: {
        editHeader: 'Modifier le thème',
        createHeader: 'Créer un thème',
        createTitle: 'Créer un nouveau thème',
        createDescription:
          'Concevez un thème personnalisé avec vos couleurs et votre style',
        namePlaceholder: 'Nom de votre thème',
        descriptionPlaceholder: 'Décrivez votre thème (optionnel)',
        iconHover: "Survol d'icône",
        nameRequired: 'Le nom du thème est requis',
        customSuffix: '(Personnalisé)',
      },
    },

    vendor: {
      title: 'Général',
      form: {
        name: 'Nom',
        contactDetails: 'Coordonnées',
        street: 'Rue',
        postcode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        timezone: 'Fuseau horaire',
        selectTimezone: 'Définir le fuseau horaire',
        organizationNumber: "N° d'enregistrement",
        phone: 'Téléphone de contact',
        email: 'E-mail de contact',
        website: "Lien vers le site de l'entreprise",
        languageDefault: 'Langue par défaut',
        selectLanguage: 'Définir la langue',
      },
      modules: {
        title: 'Modules',
        threeDView: 'Vue 3D',

        requiredAttributes: {
          title: 'Attributs requis',
          firstName: 'Prénom',
          lastName: 'Nom',
          phone: 'Téléphone',
          email: 'E-mail',
        },
        buildingAutomation: {
          title: 'Automatisation du bâtiment',
          sastechTenantId: 'ID locataire Sastech',
          ignitionProjectName: 'Nom du projet Ignition',
          gridRegion: 'Région réseau',
          selectGridRegion: '- Sélectionner la région -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Affichage public',
          loginToDisplay: 'Se connecter à l’affichage',
          invalidPassword: 'Mot de passe invalide. Réessayez.',
          password: 'Mot de passe',
          publicLink: 'Lien affichage public :',
          description:
            'Affichez les indicateurs clés du bâtiment sur un écran public sans interface',
          placeholder: 'Saisir un nouveau mot de passe',
          leaveBlankHint: 'Laisser vide pour conserver le mot de passe actuel.',
          copyButton: 'Copier',
          copySuccess: 'Lien copié dans le presse-papiers',
          saveVendorFirst: 'Enregistrez le fournisseur pour générer un jeton',
          regenerateButton: 'Régénérer le jeton',
          regenerateWarning:
            'Attention : cela rendra le lien existant invalide',
          confirmRegenerate:
            'Voulez-vous vraiment régénérer le jeton ? Le lien existant sera invalidé.',
          tokenRegenerated: 'Jeton régénéré avec succès',
          tokenRegenerateFailed: 'Échec de la régénération du jeton',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Confidentialité et anonymisation',
        activateAnonymizing: 'Activer l’anonymisation',
        privacyPolicyText: 'Définissez ici l’intervalle d’anonymisation',
        monthsToKeepData: 'Nombre de mois de conservation des données',
      },
      keyAccountManager: {
        title: 'Responsable compte clé',
        notAssigned: 'Non attribué',
      },
      tenantStatus: {
        title: 'Statut du locataire',
        tenantIsActive: 'Le locataire est actif',
        status: 'Statut',
        options: {
          development: '1. Développement',
          readyForProduction: '2. Prêt pour production',
          production: '3. Production (système)',
          deleted: 'Supprimé',
        },
        markedForDeletion: 'Marqué pour suppression',
        vendorDeletionTitle: 'Suppression du fournisseur',
        vendorDeletionDescription:
          'Le fournisseur ne sera supprimé que s’il est marqué pour suppression, que le statut est “supprimé” et qu’il est inactif. Il doit également ne pas avoir été modifié depuis plus de 30 jours.',
      },
      vendorIdLabel: 'ID fournisseur',
      successMessage: 'Fournisseur mis à jour avec succès',
      successMessagePassword: 'Fournisseur mis à jour (mot de passe modifié)',
      errorMessage: 'Échec de la mise à jour du fournisseur',
    },

    imageUpload: {
      uploadImage: 'Télécharger une image',
      noFileSelected: 'Aucun fichier sélectionné',
      uploading: 'Téléchargement…',
      fileSizeExceeded: 'La taille dépasse la limite de {{size}} Mo.',
      invalidFileType:
        'Type de fichier invalide. Veuillez sélectionner une image.',
      uploadFailed: 'Échec du téléchargement. Réessayez',
      bytes: 'octets',
      dropToReplace: "Déposez l'image pour remplacer",
      dragHint: 'Glissez-déposez ici pour remplacer',
      fromFileCloud: 'Nuage de fichiers',
      chooseFromFileCloud: 'Choisir depuis le nuage de fichiers',
    },

    fileUpload: {
      uploadImage: 'Télécharger un fichier',
      noFileSelected: 'Aucun fichier sélectionné',
      uploading: 'Téléchargement…',
      fileSizeExceeded: 'La taille dépasse la limite de {{size}} Mo.',
      invalidFileType:
        'Type de fichier invalide. Veuillez sélectionner un fichier valide.',
      uploadFailed: 'Échec du téléchargement. Réessayez',
      fileAlreadyUploaded: 'Fichier déjà téléchargé',
      uploadFile: 'Télécharger le fichier',
      viewUploadedFile: 'Voir le fichier téléchargé',
      uploadNewFile: 'Télécharger un nouveau fichier',
      fileLabel: 'Fichier :',
      sizeLabel: 'Taille :',
    },

    fileCloud: {
      title: 'Cloud de fichiers',
      storageTitle: 'Stockage',
      nameLabel: 'Nom',
      folderLabel: 'Dossier',
      sizeLabel: 'Taille',
      dateLabel: 'Date',
      buildingLabel: 'Bâtiment',
      currentPath: 'Chemin actuel',
      rootLabel: 'Accueil',
      selectedLabel: 'sélectionné(s)',
      gridViewLabel: 'Vue grille',
      listViewLabel: 'Vue liste',
      header:
        'Stockez, organisez et partagez des fichiers en toute sécurité dans votre organisation',
      uploadFiles: {
        dropZonePrompt: 'Glissez-déposez vos fichiers ici',
        selectedFilesHeader: 'Fichiers sélectionnés :',
        uploadButton: 'Télécharger',
        uploadFilesLabel: 'Télécharger des fichiers',
        uploadFolderLabel: 'Télécharger un dossier',
        uploadProgress: 'Téléchargement de {{done}} fichiers sur {{total}}…',
      },
      noFiles: 'Glissez-déposez des fichiers',
      noBuildings: 'Aucun bâtiment disponible.',
      menu: {
        download: 'Télécharger',
        rename: 'Renommer',
        delete: 'Supprimer',
        setBuilding: 'Associer un bâtiment',
        clearBuilding: 'Dissocier le bâtiment',
      },
      dialog: {
        buildingTitle: 'Sélectionner un bâtiment',
        cancelButton: 'Annuler',
        newFolderName: 'Nom du nouveau dossier',
        createFolder: 'Créer un dossier',
        renameFolder: 'Renommer le dossier',
        confirmDeleteTitle: 'Confirmer la suppression',
        confirmDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer le fichier sélectionné ?',
        confirmFolderDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer le dossier sélectionné et tout son contenu ?',
        invalidFolderName:
          'Le nom du dossier contient des caractères non valides ou est vide.',
        duplicateFolderName: 'Un dossier portant ce nom existe déjà.',
        confirmDeleteSelectedMessage:
          'Voulez-vous vraiment supprimer les fichiers sélectionnés ?',
      },
      feedback: {
        // existing
        fileDeleted: 'Fichier supprimé avec succès',
        buildingCleared: 'Bâtiment effacé avec succès',
        buildingAssigned: 'Bâtiment attribué avec succès',
        buildingUpdateError:
          'Impossible de mettre à jour la liaison au bâtiment.',

        // Restore file
        fileRestored: 'Fichier restauré avec succès.',
        restoreSuccessfulTitle: 'Restauration réussie',
        restoreErrorMessage: 'Échec de la restauration du fichier.',
        restoreErrorTitle: 'Erreur de restauration',

        // Empty garbage
        garbageEmptied: 'Corbeille vidée avec succès.',
        emptyGarbageSuccessfulTitle: 'Vidage de la corbeille réussi',
        emptyGarbageErrorMessage: 'Échec du vidage de la corbeille.',
        emptyGarbageErrorTitle: 'Erreur de vidage de la corbeille',

        // Move folder to garbage
        folderMovedToGarbage: 'Dossier déplacé vers la corbeille avec succès.',
        moveFolderToGarbageSuccessfulTitle:
          'Déplacement vers la corbeille réussi',
        moveFolderToGarbageErrorMessage:
          'Échec du déplacement du dossier vers la corbeille.',
        moveFolderToGarbageErrorTitle:
          'Erreur de déplacement vers la corbeille',

        // Rename folder
        folderRenamed: 'Dossier renommé avec succès.',
        renameFolderSuccessfulTitle: 'Renommage réussi',
        renameFolderErrorMessage: 'Échec du renommage du dossier.',
        renameFolderErrorTitle: 'Erreur de renommage',

        // Move folder
        folderMoved: 'Dossier déplacé avec succès.',
        moveFolderSuccessfulTitle: 'Déplacement réussi',
        moveFolderErrorMessage: 'Échec du déplacement du dossier.',
        moveFolderErrorTitle: 'Erreur de déplacement',

        // Delete file
        deleteSuccessfulTitle: 'Suppression réussie',
        deleteErrorMessage: 'Échec de la suppression du fichier.',
        deleteErrorTitle: 'Erreur de suppression',

        // Move file
        moveFileErrorMessage: 'Échec du déplacement du fichier.',
        moveFileErrorTitle: 'Erreur de déplacement',

        // Create folder
        createFolderErrorMessage: 'Échec de la création du dossier.',
        createFolderErrorTitle: 'Erreur de création de dossier',

        // Upload
        uploadSuccessfulMessage: 'Fichiers téléversés avec succès.',
        uploadSuccessfulTitle: 'Téléversement réussi',
        uploadErrorTitle: 'Erreur de téléversement',
      },

      newFolder: 'Nouveau dossier',
      confirmDeleteFolder:
        'Êtes-vous sûr de vouloir supprimer ce dossier et tout son contenu ?',
      moveToRoot: 'Déplacer vers la racine',
    },

    feedback: {
      vendorLoad: {
        title: 'Erreur',
        message: 'Impossible de charger les informations du fournisseur',
      },
    },
    degreeDays: {
      error: 'Le bâtiment ne dispose pas de coordonnées GPS',
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Envoyer un commentaire',
    close: 'Fermer',
    messageLabel: 'Message',
    placeholder: 'Saisissez votre commentaire ici…',
    screenshotTitle: 'Télécharger une capture d’écran',
    send: 'Envoyer',
    infoPrefix: 'Pour plus d’informations, consultez notre',
    helpCenter: 'Centre d’aide',
    statusPage: 'Page de statut',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        'Aucune inspection du bâtiment sélectionnée pour la suppression.',
      deleteConfirmMessage:
        'Êtes-vous sûr de vouloir supprimer cette inspection du bâtiment ? Cette action est irréversible.',
      deleteSuccessMessage: 'L’inspection du bâtiment a été supprimée.',
      deleteErrorMessage:
        'Échec de la suppression de l’inspection du bâtiment.',
      updateSuccessMessage: 'L’inspection du bâtiment a été mise à jour.',
      createSuccessMessage: 'L’inspection du bâtiment a été créée.',
      failedToLoadMessage:
        'Impossible de charger les inspections du bâtiment. Veuillez réessayer plus tard.',
      saveErrorMessage:
        'Impossible d’enregistrer l’inspection du bâtiment. Veuillez réessayer plus tard.',
      buildingErrorMessage:
        'Veuillez sélectionner un bâtiment pour l’inspection.',
      buildingTypeErrorMessage:
        'Veuillez sélectionner un type de bâtiment pour l’inspection.',
      failedToLoadBuildingsMessage:
        'Impossible de charger les bâtiments. Veuillez réessayer plus tard.',
      calculationsCompleteMessage: 'Calculs terminés',
      //Header
      title: 'Inspection du bâtiment',
      subtitle:
        'Complétez l’inspection du bâtiment à l’aide du formulaire ci-dessous',
      newInspectionLabel:
        'Nouvelle inspection – enregistrez pour activer plus d’options.',
      reportLabel: 'Rapport',
      actionsLabel: 'Mesures',
      generalLabel: 'Général',
      //Info
      status: {
        statusLabel: 'Statut',
        draft: 'Brouillon',
        completed: 'Terminée',
        inReview: 'En cours d’examen',
      },
      buildingLabel: 'Bâtiment',
      buildingTypeLabel: 'Type de bâtiment (Norme NF)',
      notesLabel: 'Notes',
      buildingTypes: {
        label: {
          smallHouse: 'Maison individuelle',
          apartmentBlock: 'Immeuble résidentiel',
          kinderGarden: 'Jardin d’enfants',
          officeBuilding: 'Bâtiment de bureaux',
          schoolBuilding: 'Bâtiment scolaire',
          universityCollege: 'Université / École supérieure',
          hospital: 'Hôpital',
          nursingHome: 'Maison de retraite',
          hotel: 'Hôtel',
          sportsBuilding: 'Bâtiment sportif',
          commercialBuilding: 'Bâtiment commercial',
          culturalBuilding: 'Bâtiment culturel',
          lightIndustryWarehouse: 'Bâtiment industriel léger / Entrepôt',
        },
        description: {
          smallHouse:
            'Maison individuelle, jumelée, en rangée ou autres petites habitations.',
          apartmentBlock:
            'Immeuble résidentiel à deux étages ou plus, y compris les grandes maisons en rangée à plusieurs niveaux.',
          kinderGarden:
            'Bâtiments destinés aux jardins d’enfants ou à l’éducation de la petite enfance.',
          officeBuilding:
            'Bureaux simples, bureaux avec ventilation et climatisation, ou bâtiments d’exposition et de congrès.',
          schoolBuilding:
            'Locaux d’enseignement, y compris les écoles avec piscine ou gymnase.',
          universityCollege:
            'Bâtiments universitaires ou d’écoles supérieures, laboratoires ou centres de recherche.',
          hospital:
            'Hôpitaux, hôtels pour patients ou bâtiments de laboratoires à usage médical.',
          nursingHome:
            'Maisons de retraite destinées aux soins et séjours de longue durée.',
          hotel:
            'Hôtels, bâtiments de restauration ou autres bâtiments d’hébergement.',
          sportsBuilding:
            'Salles de sport, piscines et autres installations sportives avec vestiaires et douches.',
          commercialBuilding:
            'Magasins, locaux commerciaux avec chambres froides ou stations-service.',
          culturalBuilding:
            'Cinémas, musées, bibliothèques et bâtiments religieux.',
          lightIndustryWarehouse:
            'Bâtiments industriels, entrepôts, bâtiments agricoles ou halieutiques, installations énergétiques ou autres ateliers.',
        },
      },
      mainTabs: {
        info: 'Informations',
        climate: 'Climat',
        zones: 'Zones',
        hvac: 'CVC et exploitation',
        heatingCooling: 'Chauffage et refroidissement',
        excessEnergy: 'Énergie excédentaire',
        analytics: 'Analyse',
        attachments: 'Pièces jointes',
      },
      footerButtons: {
        next: 'Suivant',
        previous: 'Précédent',
      },
      climate: {
        averageMonthlyTemp: 'Température moyenne mensuelle (°C)',
        globalIrradiation: 'Irradiation globale (kWh/m²)',
        diffuseIrradiation: 'Irradiation diffuse (kWh/m²)',
        albedo: 'Albédo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'Unités CVC',
        operationalLoads: 'Charges d’exploitation',
        productionEquipment: 'Équipements de production',
      },
      zoneManager: {
        area: 'Surface (m²)',
        noZonesCreatedYet: 'Aucune zone n’a encore été créée',
        createZoneToBegin:
          'Créez une zone pour commencer à collecter les données de l’enveloppe du bâtiment. Vous pouvez sélectionner une zone existante ou en créer une nouvelle spécifiquement pour cette inspection.',
        subTabs: {
          buildingEnvelope: 'Enveloppe du bâtiment',
          windows: 'Fenêtres',
          doors: 'Portes',
          gates: 'Portails',
          airLeakage: 'Fuites d’air',
          thermalMass: 'Masse thermique',
        },
        zoneSelector: {
          createFirstZone: 'Créer la première zone',
          addZone: 'Ajouter une zone',
          deleteSelectedZone: 'Supprimer la zone sélectionnée',
          linked: 'Lié',
        },
        zoneCreateModal: {
          zoneNameError: 'Le nom de la zone est requis.',
          createNewZoneLabel: 'Créer une nouvelle zone',
          linkExistingZoneLabel: 'Lier une zone existante',
          linkExistingZoneHelperText:
            'Sélectionnez une zone existante à lier à cette inspection.',
          selectZonePlaceholder: 'Sélectionnez une zone...',
          createNewZoneHelperText:
            'Créez une nouvelle zone qui sera ajoutée au bâtiment et utilisée pour cette inspection.',
          zoneName: 'Nom de la zone',
          description: 'Description',
          cancelButtonLabel: 'Annuler',
          addZoneTitle: 'Ajouter une zone',
          zoneNameLabel: 'Nom de la zone',
          descriptionLabel: 'Description',
        },
        exteriorWalls: 'Murs extérieurs',
        helperWithHistory: {
          north: 'Nord',
          south: 'Sud',
          east: 'Est',
          west: 'Ouest',
          count: 'Nombre',
          width: 'Largeur (m)',
          height: 'Hauteur (m)',
          addToArea: 'Ajouter à la surface (m²)',
          history: 'Historique',
          entry: ' calcul',
          entries: ' calculs',
          inputHistory: 'Historique des calculs',
          helperTitle: 'Calculateur de surface',
        },
        windows: {
          glassType: 'Type de vitrage',
          windowTypes: [
            'Aucun',
            'Simple vitrage',
            'Double vitrage',
            'Double vitrage à faible émissivité',
            'Double vitrage de contrôle solaire',
            'Triple vitrage à faible émissivité',
          ],
          totalWindowsArea: 'Surface totale des fenêtres (m²)',
          sumOfAllWindowsSurfaces: 'Somme de toutes les surfaces vitrées',
          averageUValue: 'Valeur U moyenne (W/m²K)',
          averageUValueFormula: '(Σ(U × surface)) / Σ(surface)',
          winAreaAsPercentageOfFacade: 'Surface vitrée en % de la façade',
          winAreaAsPercentageOfFacadeFormula:
            'Surface totale des fenêtres / Surface totale de façade × 100',
        },
        buildingEnvelope: {
          bra: 'Surface utile chauffée (m²)',
          floors: 'Nombre d’étages',
          floorHeight: 'Hauteur d’étage (m)',
          indoorTemperature: 'Température intérieure (°C)',
          heatedVolume: 'Volume d’air chauffé (m³)',
          heatedVolumeFormula: 'Surface utile chauffée × hauteur d’étage',
          thermalBridge: 'Pont thermique',
          thermalBridgeFormula: 'Surface chauffée × valeur normative × Kelvin',
          totalExternalWallArea: 'Surface totale des murs extérieurs',
          totalExternalWallAreaFormula:
            'Somme de toutes les surfaces de murs extérieurs',
          thermalBridgeCoefficient: 'Coefficient de pont thermique (W/mK)',
          extwWallConstruction: 'Type de construction des murs extérieurs',
          groundConditions: {
            title: 'Conditions du sol',
            options: {
              none: 'Aucune',
              clay: 'Argile',
              drySandGravel: 'Sable/gravier (sec)',
              moistSandGravel: 'Sable/gravier (humide)',
              wetSandGravel: 'Sable/gravier (saturé)',
              rock: 'Roche',
              moraine: 'Moraine',
              dryPeat: 'Tourbe (sèche)',
              moistPeat: 'Tourbe (humide)',
              wetPeat: 'Tourbe (saturée)',
              silt: 'Limons',
              organicSoil: 'Sol organique',
            },
            heatCapacity: 'Capacité thermique (J/m²K)',
            thermalConductivity: 'Conductivité thermique (W/mK)',
            groundTemperature: 'Température du sol (°C)',
          },
          grossArea: 'Surface brute (m²)',
          netArea: 'Surface nette (m²)',
          netAreaFormula: 'Surface des parois − Fenêtres − Portes − Portails',
          wallConstruction: {
            title: 'Structure de paroi',
          },
          uValue: 'Valeur U (W/m²K)',
          shadingFactor: 'Facteur d’ombrage',
          area: 'Surface (m²)',
          yearInstalled: 'Année d’installation',
          yearInstalledNone: 'Aucune',
          yearInstalledBefore1949: 'Avant 1949',
          yearInstalledFrom1997: 'À partir de 1997',
          floor: {
            area: 'Surface de plancher (m²)',
            uValue: 'Valeur U du plancher (W/m²K)',
            title: 'Plancher',
            options: {
              title: 'Type de revêtement de sol',
              standard: 'Standard',
              tiles: 'Carrelage (7 mm) + béton',
              flooringChipBoard:
                'Revêtement (4 mm) + panneau de particules 22 mm',
              flooringConcrete: 'Revêtement (4 mm) + béton',
              flooringLWA: 'Revêtement (4 mm) + dalle en béton léger',
              parquetChipBoard: 'Parquet (14 mm) + panneau de particules 22 mm',
              parquetConcrete: 'Parquet (14 mm) + béton',
              parquetLWA: 'Parquet (14 mm) + dalle en béton léger',
              carpetChipBoard: 'Moquette (10 mm) + panneau de particules 22 mm',
              carpetConcrete: 'Moquette (10 mm) + béton',
              carpetLWA: 'Moquette (10 mm) + dalle en béton léger',
            },
          },
          roof: {
            title: 'Toiture',
            optionsTitle: 'Structure de toiture',
            area: 'Surface de toiture (m²)',
            uValue: 'Valeur U de la toiture (W/m²K)',
            options: [
              'Standard',
              'Toiture compacte avec 200–250 mm de béton, 200 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 250 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 300 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 350 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 400 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 450 mm d’isolant',
              'Toiture compacte avec 200–250 mm de béton, 500 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 200 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 250 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 300 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 350 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 400 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 450 mm d’isolant',
              'Toiture compacte avec tôle nervurée, 500 mm d’isolant',
              'Toit en pente avec chevrons de 48 mm (9 % de surface), 200 mm d’isolant',
              'Toit en pente avec chevrons de 48 mm (9 % de surface), 250 mm d’isolant',
              'Toit en pente avec chevrons de 48 mm (9 % de surface), 300 mm d’isolant',
              'Toit en pente avec chevrons de 48 mm (9 % de surface), 350 mm d’isolant',
              'Toit en pente avec chevrons de 48 mm (9 % de surface), 400 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 200 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 250 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 300 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 350 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 400 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 450 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 500 mm d’isolant',
              'Toit en pente avec chevrons en profil I (6 % de surface), 550 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 200 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 250 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 300 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 350 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 400 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 450 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 500 mm d’isolant',
              'Toit avec comble froid, solives 48 mm (9 % de surface), 550 mm d’isolant',
            ],
          },
          basement: {
            title: 'Sous-sol',
            area: 'Surface de sous-sol (m²)',
            wallHeight: 'Hauteur de paroi (m)',
            wallThickness: 'Épaisseur de paroi (m)',
            baseWallConstruction: 'Structure de paroi',
            wallUValue: 'Valeur U (W/m²K)',
            heatStorage: 'Type de stockage thermique',
            effectiveHeatCapacity: 'Capacité thermique effective (kJ/m²K)',
            floorConstruction: 'Structure de plancher',
            baseWallConstructionType: 'Type de structure de paroi',
            baseWallConstructionOptions: [
              'Standard',
              'Béton 200 mm avec 100 mm d’isolant',
              'Béton 200 mm avec 150 mm d’isolant',
              'Béton 200 mm avec 200 mm d’isolant',
              'Béton 200 mm avec 250 mm d’isolant',
              'Béton 200 mm avec 300 mm d’isolant',
              'Béton 300 mm avec 100 mm d’isolant',
              'Béton 300 mm avec 150 mm d’isolant',
              'Béton 300 mm avec 200 mm d’isolant',
              'Béton 300 mm avec 250 mm d’isolant',
              'Béton 300 mm avec 300 mm d’isolant',
            ],
            heatStorageTypes: [
              'Aucun',
              'Léger (< 50 Wh/m²K)',
              'Moyen (50–100 Wh/m²K)',
              'Lourd (100–150 Wh/m²K)',
              'Très lourd (> 150 Wh/m²K)',
              'Béton 100 mm',
              'Béton 150 mm',
              'Béton 200 mm',
              'Béton 250 mm',
              'Béton 300 mm',
              'Bois',
              'Plaque de plâtre',
            ],
            floorConstructionTypes: [
              'Aucun',
              'Standard',
              'Dalle sur terre-plein avec 100 mm d’isolant',
              'Dalle sur terre-plein avec 150 mm d’isolant',
              'Dalle sur terre-plein avec 200 mm d’isolant',
              'Dalle sur terre-plein avec 250 mm d’isolant',
              'Dalle sur terre-plein avec 300 mm d’isolant',
              'Dalle sur terre-plein avec 350 mm d’isolant',
              'Dalle sur terre-plein avec 400 mm d’isolant',
              'Plancher bois avec 200 mm d’isolant',
              'Plancher bois avec 250 mm d’isolant',
              'Plancher bois avec 300 mm d’isolant',
            ],
          },
        },
        doors: {
          title: 'Type de porte',
          yearInstalled: 'Année d’installation',
          totalArea: 'Surface totale des portes',
          totalAreaFormula: 'Somme de toutes les surfaces de portes',
          avgUValue: 'Valeur U moyenne (portes)',
          avgUValueFormula: '(Σ(U × surface)) / Σ(surface)',
          percentageOfFacade: 'Surface des portes en % de la façade',
          percentageOfFacadeFormula:
            'Surface totale des portes / Surface totale de façade × 100',
          doorTypes: [
            'Aucune',
            'Standard',
            'Isolée',
            'Normale',
            'Bien isolée',
            'Non isolée',
          ],
        },
        gates: {
          title: 'Type de portail',
          yearInstalled: 'Année d’installation',
          totalArea: 'Surface totale des portails',
          totalAreaFormula: 'Somme de toutes les surfaces de portails',
          avgUValue: 'Valeur U moyenne (portails)',
          avgUValueFormula: '(Σ(U × surface)) / Σ(surface)',
          percentageOfFacade: 'Surface des portails en % de la façade',
          percentageOfFacadeFormula:
            'Surface totale des portails / Surface totale de façade × 100',
        },
        airLeakage: {
          airLeakageRate: 'Fuite d’air (l/s·m² à 50 Pa)',
          airChangeRate: 'Taux de renouvellement d’air (ACH à 50 Pa)',
          naturalVentilation: 'Ventilation naturelle',
        },
        thermalMass: {
          buildingHeatCapacity: 'Capacité thermique totale du bâtiment',
          heatCapacitySelectTitle: 'Type de bâtiment (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Plancher léger, revêtement de sol fin, parois légères',
          shortDescriptionSecondOption:
            'Plafond acoustique, moquette sur béton, parois légères',
          shortDescriptionThirdOption:
            'Béton apparent limité (20 %), parquet sur béton',
          shortDescriptionFourthOption: 'Béton principalement apparent (70 %)',
          shortDescriptionFifthOption:
            'Béton apparent au plafond, aux murs et au sol',
          labelFirstOption: 'Bâtiment très léger',
          labelSecondOption: 'Bâtiment léger',
          labelThirdOption: 'Bâtiment moyen',
          labelFourthOption: 'Bâtiment lourd',
          labelFifthOption: 'Bâtiment très lourd',
          normalizedHeatCapacity: 'Capacité thermique normalisée [Wh/(m²·K)]',
          normalizedHeatCapacityHelper:
            'D’après NS 3031 tableau B.8 – Utilisé dans les calculs énergétiques dynamiques',
          interiorWalls: 'Parois intérieures',
          north: 'Nord',
          south: 'Sud',
          east: 'Est',
          west: 'Ouest',
          claddingTitle: 'Type de parement',
          cladding: [
            'Personnalisé',
            'Standard',
            'Béton 100 mm (ou plus)',
            'Béton 80 mm',
            'Béton cellulaire',
            'Plaque de plâtre 13 mm',
            'Brique légère',
            'Béton léger (billes d’argile expansée)',
            'Bois massif (épaisseur > 40 mm)',
            'Lambris bois 15 mm',
            'Brique pleine lourde',
          ],
          claddingSubText: 'Défini par l’utilisateur',
          internalConstruction: 'Structure intérieure',
          heatCapacity: 'Capacité thermique [Wh/m²K]',
          grade: 'Classe',
          furniture: {
            title: 'Mobilier',
            options: ['Aucun', 'Standard', 'Léger', 'Moyen', 'Lourd'],
          },
          thermalHeatCapacityLabel: 'Capacité thermique du bâtiment',
          thermalHeatCapacityFormula:
            'Surface utile chauffée × valeur normative / 1000 (Norme : Aucun = 0, Léger = 40, Moyen = 60, Lourd = 80 Wh/m²K)',
          floorSeparationsAreaLabel:
            'Surface des planchers intermédiaires (m²)',
          internalFloorsTooltip:
            'Planchers intérieurs entre niveaux : surface utile chauffée × (nombre d’étages − 1) / nombre d’étages',
        },
      },
    },
    report: {
      noReportYetTitle: 'Aucun rapport pour le moment',
      noReportYetDescription:
        'Créez un premier brouillon de rapport pour commencer la documentation de l’inspection.',
      noReportYetSubDescription:
        'Le rapport comprendra des chapitres, des champs de texte et des pièces jointes organisés de manière structurée.',
      creatingDraft: 'Création du brouillon…',
      createDraft: 'Créer un brouillon',

      title: 'Rapport',
      reportGenerationHint1:
        'Pour générer le rapport, le statut de l’inspection doit être défini comme terminé.',
      reportGenerationHint2:
        'Les rapports sont générés toutes les quinze minutes.',
      reportGenerationHint3:
        'Les données sont récupérées depuis l’inspection lorsque le statut est défini comme terminé.',

      statusDraft: 'Brouillon',
      statusAiGenerate: 'Génération IA',
      statusComplete: 'Terminé',

      reportGenerationTitle: 'Génération du rapport',
      reportGenerationLine1:
        'Pour générer le rapport, le statut de l’inspection doit être défini comme terminé. Les rapports sont générés toutes les quinze minutes.',
      reportGenerationLine2:
        'Les données sont récupérées depuis l’inspection lorsque le statut est défini comme terminé.',

      tableOfContents: 'Table des matières',

      olderVersionWarning:
        'Attention ! Vous consultez une version antérieure de ce rapport.',

      saving: 'Enregistrement…',
      saveReport: 'Enregistrer le rapport',
      deleteReport: 'Supprimer le rapport',

      confirmDeletionTitle: 'Confirmer la suppression',
      confirmDeleteReportMessage:
        'Êtes-vous sûr de vouloir supprimer ce rapport ?',
      confirmDeleteTextFieldMessage:
        'Êtes-vous sûr de vouloir supprimer ce champ de texte ?',

      addField: 'Ajouter un champ',
      fieldSingular: 'champ',
      fieldsPlural: 'champs',

      aiPrompt: 'Invite IA',
      reportText: 'Texte du rapport',
      attachments: 'Pièces jointes',
      addImage: 'Ajouter une image',

      aiLabel: 'IA',
      scoreLabel: 'Score',

      versionLabel: 'Version',

      exportToWord: 'Exporter vers Word',
      exportingWord: 'Exportation...',
      wordExportProgress: {
        starting: "Démarrage de l'exportation...",
        capturingCharts: 'Capture des graphiques...',
        capturingDetails: 'Capture des détails de calcul...',
        buildingDocument: 'Création du document...',
        savingFile: 'Enregistrement du fichier...',
        complete: 'Exportation terminée',
        error: "Échec de l'exportation. Veuillez réessayer.",
      },
    },
    UserCalendar: {
      createYourActivity: 'Créez votre activité',
      categoryErrorMessage: 'Catégorie manquante',
      titleErrorMessage: 'Titre manquant',
      createActivity: 'Créer une activité',
      editActivity: 'Modifier l’activité',
      confirmDeletion: 'Confirmer la suppression',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer cette activité ?',
    },
  },
  attachments: {
    notes: 'Notes',
    description: 'Description',
    replaceImage: 'Remplacer l’image',
    addImage: 'Ajouter une image',
    removeAttachment: 'Supprimer la pièce jointe',
    tags: 'Sujets',
    uploadImage: 'Télécharger une capture d’écran',
  },
  buildingControlProfile: {
    inOperationTitle: 'En opération',
    outsideOperationTitle: 'Hors opération',
    temperatureLower: 'Limite inférieure de température (°C)',
    temperatureUpper: 'Limite supérieure de température (°C)',
    humidityLower: 'Limite inférieure d’humidité (%)',
    humidityUpper: 'Limite supérieure d’humidité (%)',
    co2Tooltip: 'Niveau maximal de CO₂ autorisé, mesuré en ppm.',
    refreshInterval: 'Intervalle de rafraîchissement',
    refreshIntervalHelp: 'À quelle fréquence l’ASPA vérifie ces paramètres.',
    comfortWeight: 'Poids du confort',
    energy: 'Énergie',
    comfort: 'Confort',
    costInfo:
      'L’optimiseur équilibre la consommation d’énergie et le confort. Un poids de confort faible privilégie une faible consommation d’énergie, tandis qu’un poids de confort élevé privilégie un meilleur confort. Les deux valeurs sont calculées sur une échelle de 0 à 1.',
  },
  gridRegions: {
    label: 'Zone électrique',
    placeholder: '- Sélectionner une zone -',
    groups: {
      nordic: 'Pays nordiques',
      centralEurope: 'Europe centrale',
      southernEurope: 'Europe du Sud',
      baltic: 'États baltes',
      britishIsles: 'Îles britanniques',
      easternEurope: 'Europe de l’Est',
    },
    areas: {
      NO1: 'Oslo / Norvège de l’Est',
      NO2: 'Kristiansand / Norvège du Sud',
      NO3: 'Trondheim / Norvège centrale',
      NO4: 'Tromsø / Norvège du Nord',
      NO5: 'Bergen / Norvège de l’Ouest',
      SE1: 'Nord de la Suède',
      SE2: 'Centre-nord de la Suède',
      SE3: 'Centre de la Suède',
      SE4: 'Sud de la Suède',
      DK1: 'Ouest du Danemark (Jutland-Fionie)',
      DK2: 'Est du Danemark (Sjælland)',
      FI: 'Finlande',
      DE_LU: 'Allemagne-Luxembourg',
      AT: 'Autriche',
      BE: 'Belgique',
      NL: 'Pays-Bas',
      FR: 'France',
      CH: 'Suisse',
      CZ: 'Tchéquie',
      PL: 'Pologne',
      SK: 'Slovaquie',
      HU: 'Hongrie',
      SI: 'Slovénie',
      HR: 'Croatie',
      IT_NORTH: 'Italie Nord',
      IT_CNORTH: 'Italie Centre-Nord',
      IT_CSOUTH: 'Italie Centre-Sud',
      IT_SOUTH: 'Italie Sud',
      IT_SICILY: 'Italie Sicile',
      IT_SARDINIA: 'Italie Sardaigne',
      ES: 'Espagne',
      PT: 'Portugal',
      GR: 'Grèce',
      EE: 'Estonie',
      LV: 'Lettonie',
      LT: 'Lituanie',
      GB: 'Grande-Bretagne',
      IE_SEM: 'Irlande (SEM)',
      RO: 'Roumanie',
      BG: 'Bulgarie',
      RS: 'Serbie',
      ME: 'Monténégro',
      AL: 'Albanie',
      MK: 'Macédoine du Nord',
      BA: 'Bosnie-Herzégovine',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Rechercher par adresse',
    placeholder: 'Rue, numéro et lieu',
    moreHint:
      'Affiche {shown} sur {total}. Ajoutez un lieu ou un code postal pour affiner la recherche.',
    noHitsHint:
      'Aucun résultat. Ajoutez le numéro et la ville, par exemple Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Certificat énergétique',
    language: 'Langue',
    themeLight: 'Passer au thème clair',
    themeDark: 'Passer au thème sombre',
    title: 'Étiquette énergie',
    loggedInAs: 'Connecté en tant que',
    logout: 'Se déconnecter',
    login: {
      title: 'Se connecter',
      phoneDescription:
        'Connectez-vous avec le numéro de téléphone utilisé lors de votre demande de certificat énergétique (Energiattest). Un code de vérification est envoyé par SMS.',
      codeDescription: 'Saisissez le code à six chiffres reçu par SMS.',
      phone: 'Numéro de téléphone',
      phonePlaceholder: '6 12 34 56 78',
      countryCode: 'Indicatif du pays',
      phoneHint: 'Le numéro indiqué lors de votre demande.',
      code: 'Code de vérification',
      codeHint: 'Six chiffres reçus par SMS.',
      codeSentTo: 'Code envoyé au',
      sendCode: 'Envoyer le code',
      verify: 'Vérifier',
      changePhone: 'Utiliser un autre numéro de téléphone',
    },
    flow: {
      navTitle: 'Comment procéder',
      draftSavedAt: 'Votre brouillon — dernier enregistrement',
      continueLater: 'Vous pouvez fermer et continuer plus tard.',
      draft: 'Brouillon',
      saveAndClose: 'Enregistrer et fermer',
      autosaved: 'Vos réponses sont enregistrées automatiquement.',
      submitted: {
        title: 'Envoyé',
        body: 'Merci. Un conseiller en énergie examinera vos réponses.',
      },
      back: 'Retour',
      next: 'Suivant',
      submit: 'Envoyer',
      stepsMenu: 'Étapes',
      whyWeAsk: 'Pourquoi cette question ?',
      validation: {
        range: 'Doit être compris entre {min} et {max}.',
        min: 'Doit être au moins {min}.',
        max: 'Ne peut pas dépasser {max}.',
        positive: 'Doit être supérieur à zéro.',
      },
      select: 'Sélectionner',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'n° de bâtiment',
      building: {
        address: 'Adresse',
        buildingNumber: 'N° de bâtiment',
        cadastre: 'Gnr / bnr',
        buildingType: 'Type de bâtiment',
        usableArea: 'Surface utile (BRA)',
        footprint: 'Emprise au sol',
      },
      cadastre: {
        notFound:
          'Le bâtiment est introuvable dans le cadastre. Renseignez ce que vous savez.',
      },
      yesNo: { yes: 'Oui', no: 'Non', dontKnow: 'Je ne sais pas' },
      status: {
        completed: 'Terminé',
        defaults: 'Valeurs par défaut',
        notApplicable: 'Sans objet',
      },
      steps: {
        confirmBuilding: {
          nav: 'Confirmer le bâtiment',
          title: 'Confirmer le bâtiment',
          eyebrow: 'Trouvé via GPS et le cadastre',
          question: 'Est-ce votre bâtiment ?',
          body: "Nous avons marqué le bâtiment le plus proche de votre position. Vérifiez que l'adresse et le numéro de bâtiment sont corrects avant de continuer.",
          wrongHint:
            "Ce n'est pas le bon ? Appuyez sur le bon bâtiment sur la carte, ou recherchez par adresse.",
          searchAddress: 'Rechercher par adresse',
          mapTitle: 'Sélecteur de bâtiment',
          noBuilding:
            'Aucun bâtiment trouvé ici. Rapprochez le repère du bâtiment.',
        },
        aboutBuilding: {
          nav: 'À propos du bâtiment',
          title: 'À propos du bâtiment',
          lead: 'La plupart des informations ci-dessous proviennent du cadastre. Corrigez ce qui est inexact — le certificat repose sur ces chiffres.',
          aside: {
            title: 'Catégorie, année de construction et surface',
            body: "La catégorie du bâtiment, l'année de construction et la surface utile sont la base de tout le calcul. La catégorie fixe les valeurs par défaut, l'année de construction indique quelle réglementation s'appliquait, et la surface détermine combien d'énergie le bâtiment consomme par mètre carré.",
          },
          sections: {
            category: {
              title: 'Catégorie de bâtiment',
              description:
                'La catégorie détermine les valeurs par défaut utilisées par la suite.',
            },
            area: {
              title: 'Surface et hauteur',
              description: "L'emprise au sol peut aussi être lue sur la carte.",
            },
          },
          fields: {
            category: {
              label: 'Catégorie',
              hint: 'Repris du cadastre lorsque le bâtiment y figure.',
            },
            subcategory: {
              label: 'Sous-catégorie',
              hint: 'Repris du cadastre lorsque le bâtiment y figure.',
            },
            buildYear: {
              label: 'Année de construction',
              hint: "L'année de début des travaux, si connue.",
            },
            floors: {
              label: "Nombre d'étages",
              hint: 'Hors sol. Le sous-sol est ajouté plus tard.',
            },
            footprint: {
              label: 'Emprise au sol',
              hint: 'Du cadastre ou de la carte.',
            },
            usableArea: {
              label: 'Surface utile totale (BRA)',
              hint: 'Surface de plancher totale de tous les niveaux, mesurée à l’intérieur des murs extérieurs.',
            },
            heatedArea: {
              label: 'Surface utile chauffée',
              hint: 'La surface chauffée à plus de 15 °C.',
            },
            floorHeight: {
              label: "Hauteur d'étage moyenne",
              hint: 'Laissez vide si vous ne savez pas, la valeur standard de la catégorie sera utilisée.',
            },
          },
          options: {
            categories: {
              kontor: 'Immeuble de bureaux',
              lettIndustri: 'Industrie légère',
              lager: 'Entrepôt',
              forretning: 'Bâtiment commercial',
              skole: 'Bâtiment scolaire',
              hotell: 'Bâtiment hôtelier',
            },
            subcategories: {
              lettindustriLager: 'Industrie légère et entrepôt',
              verksted: 'Atelier',
              produksjon: 'Hall de production',
            },
          },
          knowMore: 'En savez-vous plus sur les surfaces ?',
        },
        envelope: {
          nav: 'Enveloppe du bâtiment',
          title: 'Enveloppe du bâtiment',
          lead: 'La construction des murs extérieurs détermine la quantité de chaleur perdue par le bâtiment. Choisissez ce qui ressemble le plus.',
          sections: {
            walls: {
              title: 'Murs extérieurs',
              description:
                "Le matériau et l'épaisseur déterminent la chaleur que les murs laissent s'échapper.",
            },
            more: {
              title: "Qu'a le bâtiment d'autre ?",
              description:
                'Ce que vous cochez ici ouvre des étapes dédiées dans le menu.',
            },
          },
          fields: {
            construction: {
              label: 'Construction',
              hint: "Le type le plus courant s'il y en a plusieurs.",
            },
            insulation: {
              label: "Épaisseur d'isolation",
              hint: "Laissez vide si vous ne savez pas — nous utilisons le standard de l'année de construction.",
            },
          },
          options: {
            walls: {
              tre: 'Bois',
              mur: 'Maçonnerie',
              staal: 'Acier',
              betong: 'Béton',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Sous-sol ou niveau inférieur' },
            knowWindows: { label: 'Fenêtres' },
            doors: { label: 'Portes' },
            gates: { label: 'Portails' },
          },
          aside: {
            title: 'Murs et déperdition thermique',
            body: "Une grande partie de la chaleur d'un bâtiment s'échappe par les murs. Le matériau et l'isolation indiquent au conseiller si le bâtiment garde bien sa chaleur. Choisissez ce qui ressemble le plus, le conseiller calcule le reste.",
          },
        },
        basement: {
          nav: 'Sous-sol',
          title: 'Sous-sol',
          lead: "Le niveau inférieur est calculé différemment car il est en contact avec le sol et non avec l'air extérieur.",
          aside: {
            title: 'Sous-sol en contact avec le sol',
            body: "Un sous-sol est en contact avec le sol, pas avec l'air extérieur. Le sol garde une température plus stable au fil de l'année, les pertes de chaleur sont donc calculées différemment que pour les murs hors sol. Le fait que le sous-sol soit chauffé détermine s'il compte dans la surface chauffée. Renseignez ce que vous savez, les champs vides reçoivent des valeurs par défaut.",
          },
          section: {
            title: 'Le niveau inférieur',
            description:
              'Seulement ce que vous savez. Les champs vides reçoivent des valeurs par défaut.',
          },
          checks: {
            heated: {
              label: 'Le niveau inférieur est chauffé',
              description:
                'Un sous-sol non chauffé est considéré comme tampon avec le sol.',
            },
          },
          fields: {
            floorArea: { label: 'Surface au sol du sous-sol' },
            wallLength: { label: 'Longueur des murs extérieurs' },
            floorHeight: { label: "Hauteur d'étage" },
            wallThickness: { label: 'Épaisseur des murs du sous-sol' },
            depth: {
              label: 'Profondeur moyenne sous le niveau du sol',
              hint: 'À quelle profondeur le sous-sol se situe dans le terrain.',
            },
          },
          knowMore: 'En savez-vous plus sur le sous-sol ?',
        },
        windows: {
          nav: 'Fenêtres',
          title: 'Fenêtres',
          lead: 'Les fenêtres représentent une grande part de la déperdition thermique — et des apports solaires. La répartition par orientation compte le plus.',
          sections: { area: { title: 'Les fenêtres du bâtiment' } },
          checks: {
            even: {
              label:
                'Toutes les fenêtres sont réparties uniformément sur le bâtiment',
              description:
                'Nous répartissons la surface totale à parts égales sur quatre façades.',
            },
          },
          fields: {
            windowType: {
              label: 'Type de fenêtre',
              hint: "Le type le plus courant s'il y en a plusieurs.",
            },
            totalArea: { label: 'Surface vitrée totale' },
            installYear: {
              label: "Année d'installation des fenêtres",
              hint: "L'année où les fenêtres les plus récentes ont été posées.",
            },
            north: { label: 'Nord' },
            east: { label: 'Est' },
            south: { label: 'Sud' },
            west: { label: 'Ouest' },
          },
          aside: {
            title: 'Orientation',
            body: "Les fenêtres orientées au sud laissent entrer le plus de chaleur solaire et réduisent les besoins de chauffage. Au nord, ce n'est presque que de la déperdition. C'est pourquoi nous demandons par façade.",
          },
          knowMore: 'En savez-vous plus sur les fenêtres ?',
        },
        doors: {
          nav: 'Portes et portails',
          title: 'Portes et portails',
          lead: "Les portes et les portails font partie de l'enveloppe du bâtiment, et le type en dit long sur les pertes de chaleur. Renseignez ce que vous savez ou ce dont vous vous souvenez, le reste reçoit des valeurs par défaut.",
          only: {
            doors: {
              nav: 'Portes',
              title: 'Portes',
              lead: "Les portes extérieures font partie de l'enveloppe du bâtiment, et le type en dit long sur les pertes de chaleur. Renseignez ce que vous savez ou ce dont vous vous souvenez, le reste reçoit des valeurs par défaut.",
              aside: {
                title: 'Portes et pertes de chaleur',
                body: "Une porte extérieure laisse échapper plus de chaleur que le mur qui l'entoure. Le type de porte indique au conseiller à peu près à quel point elle isole. Ce que vous ne savez pas, le conseiller le calcule à partir de l'année de construction et des valeurs par défaut.",
              },
            },
            gates: {
              nav: 'Portails',
              title: 'Portails',
              lead: "Les portails sont souvent les plus grandes ouvertures de l'enveloppe du bâtiment, et le type en dit long sur les pertes de chaleur. Renseignez ce que vous savez ou ce dont vous vous souvenez, le reste reçoit des valeurs par défaut.",
              aside: {
                title: 'Portails et pertes de chaleur',
                body: "Les portails sont souvent les plus grandes ouvertures du bâtiment, et ils restent souvent ouverts par périodes. Le type de portail indique au conseiller à peu près à quel point ils isolent. Ce que vous ne savez pas, le conseiller le calcule à partir de l'année de construction et des valeurs par défaut.",
              },
            },
          },
          aside: {
            title: 'Portes, portails et pertes de chaleur',
            body: "Les portes et les portails laissent échapper plus de chaleur que le mur qui les entoure, et les portails restent souvent ouverts par périodes. Le type indique au conseiller à peu près à quel point ils isolent. Ce que vous ne savez pas, le conseiller le calcule à partir de l'année de construction et des valeurs par défaut.",
          },
          sections: {
            doors: {
              title: 'Portes',
              description: 'Portes extérieures pour les personnes.',
            },
            gates: {
              title: 'Portails',
              description: 'Portes de garage, portes de quai et similaires.',
            },
          },
          fields: {
            doorType: {
              label: 'Type de porte',
              hint: "Le type le plus courant s'il y en a plusieurs.",
            },
            installYear: { label: "Année d'installation" },
            uValue: {
              label: 'Valeur U, moyenne',
              hint: 'Laissez vide si vous ne savez pas.',
            },
            gateType: {
              label: 'Type de portail',
              hint: "Le type le plus courant s'il y en a plusieurs.",
            },
            area: { label: 'Surface' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Porte en acier',
              glass: 'Porte vitrée',
              tre: 'Porte en bois',
              aluminium: 'Porte en aluminium',
            },
            gateTypes: {
              leddportIsolert: 'Porte sectionnelle isolée',
              leddport: 'Porte sectionnelle non isolée',
              rulleport: 'Porte à enroulement',
              hurtigport: 'Porte rapide',
            },
          },
          knowMoreDoors: 'En savez-vous plus sur les portes ?',
          knowMoreGates: 'En savez-vous plus sur les portails ?',
        },
        energySources: {
          nav: "Sources d'énergie",
          title: "Sources d'énergie",
          lead: "Quelles sources d'énergie le bâtiment possède-t-il ? Les choix ici ouvrent les étapes suivantes.",
          sections: {
            delivered: {
              title: 'Énergie livrée',
              description: 'Cochez tout ce qui est raccordé au bâtiment.',
            },
            own: { title: 'Production propre' },
          },
          checks: {
            electricity: {
              label: 'Électricité',
              description:
                "Tous les bâtiments ont l'électricité. L'électricité seule donne un calcul simplifié.",
            },
            districtHeating: {
              label: 'Chauffage urbain',
              description: "Ouvre l'étape Installation de chauffage central.",
            },
            heatPump: {
              label: 'Pompe à chaleur',
              description: "Ouvre l'étape Pompe à chaleur.",
            },
            fossil: {
              label: 'Fioul, gaz ou bio',
              description: "Ouvre l'étape Chaudière.",
            },
            other: {
              label: "Autres sources d'énergie",
              description:
                'Décrivez-les dans le champ de commentaire de la dernière étape.',
            },
            solar: {
              label: 'Le bâtiment a une installation photovoltaïque',
              description: "Ouvre l'étape Panneaux solaires.",
            },
          },
          aside: {
            title: 'Chauffage central',
            body: "Le chauffage urbain, la pompe à chaleur et les chaudières peuvent tous être raccordés à une même installation de chauffage central. À l'étape suivante, nous demandons comment ils se partagent le chauffage et l'eau chaude.",
          },
        },
        centralHeating: {
          nav: 'Installation de chauffage central',
          title: 'Installation de chauffage central',
          lead: "Sources d'énergie sélectionnées — voici comment elles sont configurées dans l'installation de chauffage central.",
          sections: {
            plant: { title: "L'installation" },
            districtHeating: {
              title: 'Réseau de chaleur',
              description:
                'Comment le réseau de chaleur est utilisé dans le bâtiment.',
            },
          },
          fields: {
            location: {
              label: 'Emplacement',
              hint: 'Où se trouve la chaufferie.',
            },
            installYear: { label: "Année d'installation" },
            connectedTo: {
              label: 'Raccordé à',
              hint: "Où va l'eau.",
            },
          },
          options: {
            locations: {
              tekniskRom: 'Local technique',
              kjeller: 'Sous-sol',
              tak: 'Toit',
              egetBygg: 'Bâtiment séparé',
            },
            connections: {
              oppvarming: 'Chauffage',
              oppvarmingVent: 'Chauffage et ventilation',
            },
          },
          checks: {
            forHeating: { label: 'Chauffage des locaux' },
            forHotWater: { label: 'Eau chaude sanitaire' },
          },
          aside: {
            title: 'La chaleur part de la chaufferie',
            body: "Le chauffage central transporte la chaleur des sources d'énergie dans le bâtiment sous forme d'eau. L'emplacement de la chaufferie, et le fait que l'eau chauffe aussi l'air de ventilation, déterminent la quantité de chaleur perdue en chemin. Si les informations vous manquent, nous utilisons des valeurs par défaut.",
          },
        },
        heatPump: {
          nav: 'Pompe à chaleur',
          title: 'Pompe à chaleur',
          lead: "Type et performance de la pompe à chaleur. La puissance et la consommation figurent généralement sur la plaque signalétique ou dans le carnet d'entretien.",
          sections: {
            plant: { title: "L'installation" },
            connection: { title: 'Raccordement' },
          },
          fields: {
            type: { label: 'Type' },
            installYear: { label: "Année d'installation" },
            power: {
              label: 'Puissance',
              hint: 'Puissance calorifique nominale de la plaque signalétique.',
            },
            annualUse: {
              label: 'Consommation annuelle',
              hint: "Du compteur électrique ou du système de régulation, s'il existe.",
            },
          },
          options: {
            types: {
              luftLuft: 'Air–air',
              luftVann: 'Air–eau',
              vaeskeVann: 'Eau glycolée–eau',
              avtrekk: 'Pompe à chaleur sur air extrait',
            },
          },
          checks: {
            connected: {
              label:
                "La pompe à chaleur est raccordée à l'installation de chauffage central",
              description:
                "La part est définie à l'étape Chauffage et refroidissement.",
            },
          },
          knowMore: 'En savez-vous plus sur la pompe à chaleur ?',
          aside: {
            title: "Plus de chaleur que d'électricité",
            body: "Une pompe à chaleur puise la chaleur dans l'air, l'eau ou le sol et fournit plus de kilowattheures de chaleur qu'elle ne consomme d'électricité. Le type, la puissance et l'âge déterminent son efficacité, ce qui se répercute directement sur l'étiquette énergétique. Si les chiffres vous manquent, nous utilisons des valeurs par défaut.",
          },
        },
        boiler: {
          nav: 'Chaudière',
          title: 'Chaudière',
          lead: 'La chaudière alimentée au fioul, au gaz ou à la biomasse. La puissance figure généralement sur la plaque signalétique.',
          sections: { plant: { title: 'La chaudière' } },
          fields: {
            fuelType: { label: 'Type de chaudière' },
            power: {
              label: 'Puissance à pleine charge',
              hint: 'De la plaque signalétique ou de la documentation.',
            },
          },
          options: {
            fuelTypes: { olje: 'Fioul', gass: 'Gaz', bio: 'Biomasse' },
          },
          aside: {
            title: 'Le combustible compte différemment',
            body: "Le fioul, le gaz et la biomasse sont pondérés différemment dans le certificat énergétique, le type de chaudière influence donc à la fois l'étiquette énergétique et la note de chauffage. La puissance indique quelle part des besoins de chauffage la chaudière peut couvrir. Si les chiffres vous manquent, nous utilisons des valeurs par défaut.",
          },
        },
        solar: {
          nav: 'Panneaux solaires',
          title: 'Panneaux solaires',
          lead: "L'électricité autoproduite est déduite de l'énergie livrée dans le certificat.",
          sections: {
            plant: {
              title: "L'installation photovoltaïque",
              description:
                "Les chiffres figurent généralement dans la documentation de l'installateur ou dans l'application de l'installation.",
            },
            hotWater: { title: 'Eau chaude' },
          },
          fields: {
            installedPower: {
              label: 'Puissance installée',
              hint: "Figure dans la documentation de l'installation.",
            },
            installYear: { label: "Année d'installation" },
            annualProduction: {
              label: 'Production annuelle',
              hint: "De l'onduleur ou de l'application de l'installation.",
            },
            panelArea: { label: 'Surface des panneaux' },
          },
          checks: {
            hotWaterConnected: {
              label: "L'eau chaude est raccordée à l'installation centrale",
              description:
                "Voir sources d'énergie. Sinon l'eau chaude est considérée comme électrique.",
            },
          },
          aside: {
            title: 'Votre propre électricité compte',
            body: "L'électricité des panneaux solaires couvre une partie de ce que le bâtiment consomme, ce qui peut donner une meilleure étiquette énergie. C'est pourquoi nous devons connaître la taille de l'installation. Si les chiffres vous manquent, indiquez-le dans le champ de commentaire de la dernière étape.",
          },
          knowMore: 'En savez-vous plus sur l’installation solaire ?',
        },
        ventilation: {
          nav: 'Ventilation',
          systemTitle: 'Installation {number}',
          title: 'Ventilation',
          lead: 'Le bâtiment a-t-il une installation de ventilation ?',
          sections: {
            type: {
              title: 'Installation de ventilation',
              description:
                'Seule la ventilation double flux demande plus de détails.',
            },
            plant: {
              title: "L'installation",
              description:
                "Une centrale souffle de l'air frais et extrait l'air vicié, souvent avec récupération de chaleur.",
            },
            capacity: {
              title: 'Capacité — par installation',
              description:
                'Si la capacité dépasse la valeur minimale, elle doit être indiquée.',
            },
            maintenance: { title: 'Entretien' },
          },
          fields: {
            hasSystems: {
              label:
                'Le bâtiment dispose-t-il d’une installation de ventilation ?',
            },
            count: {
              label: "Nombre d'installations",
              hint: 'Vous obtenez un jeu de champs par installation.',
            },
            type: { label: 'Type' },
            installYear: { label: "Année d'installation" },
            airflowOperating: {
              label: "Débit d'air en période d'occupation",
            },
            airflowOff: { label: "Débit d'air hors période d'occupation" },
            lastMaintenance: {
              label: 'Date du dernier entretien',
              hint: "Du rapport d'entretien.",
            },
            regularMaintenance: {
              label: "Entretien régulier de l'installation ?",
            },
            moreInfo: {
              label:
                "Avez-vous d'autres informations sur la ventilation pour le conseiller ?",
              hint: 'Remplacement des filtres, horaires de fonctionnement, anomalies connues.',
            },
            heatRecovery: {
              label: 'Rendement de récupération de chaleur',
              hint: 'D’après la documentation de la centrale.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label:
                "Pompe à chaleur sur air rejeté raccordée à l'installation centrale",
            },
            extractHeatPump: {
              label:
                "Pompe à chaleur sur air extrait raccordée à l'installation centrale",
            },
          },
          options: {
            types: {
              avtrekk: 'Extraction mécanique',
              balansert: 'Ventilation double flux',
            },
            typeDescriptions: {
              avtrekk:
                'Une grande partie du bâtiment a une extraction mécanique.',
            },
          },
          aside: {
            title: 'Air et chaleur',
            body: "La ventilation remplace l'air intérieur vicié par de l'air extérieur frais. Une installation qui récupère la chaleur de l'air sortant économise beaucoup d'énergie. Si les chiffres vous manquent, nous utilisons des valeurs par défaut.",
          },
          knowMore: 'En savez-vous plus sur la ventilation ?',
        },
        heating: {
          nav: 'Chauffage et refroidissement',
          title: 'Chauffage et refroidissement',
          lead: "Les propositions ci-dessous sont basées sur les sources d'énergie et la ventilation que vous avez choisies. Indiquez la part couverte par chaque solution, si vous la connaissez.",
          groups: {
            electric: { title: 'Chauffage électrique' },
            central: { title: 'Chauffage central' },
          },
          options: {
            electric: {
              panelHeaters: 'Panneaux rayonnants',
              convectors: 'Convecteurs',
              electricBoiler: "Chaudière électrique avec ballon d'eau chaude",
              electricFloor: 'Plancher chauffant',
              ventilationHeat: 'Chauffage par la ventilation',
              airToAir: 'Pompe à chaleur air–air',
            },
            central: {
              radiators: 'Radiateurs',
              convectors: 'Convecteurs',
              waterFloor: 'Plancher chauffant',
              ventilationHeat: 'Chauffage par la ventilation',
            },
          },
          sections: { cooling: { title: 'Refroidissement' } },
          checks: {
            hasCooling: {
              label: 'Le bâtiment a un système de refroidissement',
              description:
                'Groupe froid, réseau de froid urbain ou pompe à chaleur en mode refroidissement.',
            },
          },
          aside: {
            title: 'Renseignez ce que vous savez',
            body: "Si vous ne savez pas, vous n'avez pas besoin de remplir les champs. Renseignez ce que vous savez, ce dont vous avez une idée, ou des valeurs approximatives. Plus de détails donnent au conseiller énergie une meilleure base.",
          },
          singleShare: 'Nous supposons que celle-ci couvre tout le chauffage.',
        },
        summary: {
          nav: 'Récapitulatif et envoi',
          title: 'Récapitulatif et envoi',
          lead: 'Le certificat énergétique est plus précis — et souvent meilleur — lorsque davantage de champs sont remplis.',
          alert: {
            title: '{count} étapes utilisent des valeurs par défaut',
            body: "Des données insuffisantes signifient que l'évaluation énergétique est réalisée sur la base d'informations limitées. Une partie des installations techniques et du bâtiment est alors calculée avec des valeurs par défaut. Vous pouvez envoyer maintenant, ou revenir en arrière et compléter pour une étiquette plus précise.",
          },
          registered: 'Ce que vous avez enregistré',
          confirmFirst:
            "Confirmez que les informations sont fournies de bonne foi avant d'envoyer.",
          sections: { advisor: { title: 'Pour le conseiller' } },
          fields: {
            note: {
              label:
                "Y a-t-il quelque chose que le conseiller devrait savoir sur les flux d'énergie et la consommation ?",
              hint: 'Par exemple : une partie du bâtiment est vide, réduction nocturne et le week-end, remplacements récents, fuites connues.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'Toutes les informations ont été saisies au mieux de ma connaissance et de bonne foi',
              description:
                'Le conseiller utilise vos réponses comme base pour le certificat énergétique. Vous pourrez corriger plus tard si quelque chose était inexact.',
            },
          },
          aside: {
            eyebrow: 'Et maintenant ?',
            title: 'Votre saisie est transmise au conseiller',
            body: "Un conseiller en énergie vérifie vos réponses et transmet le certificat énergétique à Enova. Personne n'a besoin de se rendre sur place. Vous serez informé lorsque le certificat sera prêt.",
          },
        },
      },
      knowInstallYear: 'Connaissez-vous l’année d’installation ?',
      assumeBuildYear: 'Nous supposons qu’elle date de {year}.',
      buildYearWord: 'l’année de construction',
      assumeStandard: 'Nous supposons des valeurs standard.',
    },
  },
};

export default FRENCH;
